<template lang="pug">
el-form(ref='titles', :inline='true', :model='application.titles', label-width='160px', size='small')
  el-form-item(label='Τύπος Φοίτησης')
    | {{distant}}
  el-form-item(label='Μερική', v-show="distant === 'Συμβατικός'")
    | {{application.titles.partTime ? 'Ναι' : 'Όχι'}}
  div(v-show="distant === 'Εξ αποστάσεως'")
    el-form-item(label=' ')
      el-checkbox(label='Μέρος έγινε στην Ελλάδα', name='application.titles.partOfStudiesGr',
      v-model='application.titles.partOfStudiesGr', :disabled='true')
    el-form-item(label='Πόλη', v-show='application.titles.partOfStudiesGr')
      | {{application.titles.cityOfStudiesGr}}
    el-form-item(label='Ίδρυμα', v-show='application.titles.partOfStudiesGr')
      | {{application.titles.institutionOfStudiesGr}}
  div(v-show="application.degreeType !== 'bachelor'")
    el-form-item(label='Βασικό Πτυχίο σε')
      el-switch(v-model="application.titles.greekBachelor", active-text="Ελληνικό Πανεπιστήμιο",
        inactive-text="Πανεπιστήμιο του εξωτερικού", :disabled='true')
    el-form-item(label='Τμήμα Πανεπιστημίου', v-show='application.titles.greekBachelor')
      | {{application.titles.greekBachelorInserted}}
    el-form-item(label='Πράξη αναγνώρισης', v-show='!application.titles.greekBachelor')
      | {{application.titles.greekBachelorInserted}}
    el-form-item(label='Με Βαθμολογική Αντιστοίχιση' v-show='application.degreeType === "master"')
      | {{ scoreMatchString }}
  hr
  el-form-item(label='Χώρα Σπουδών' v-if='application.titles.country.name !== null && application.titles.country.name !== "other"')
    | {{application.titles.country.name}}
  el-form-item(label='Χώρα Σπουδών' v-if='application.titles.country.name === "other"')
    | {{application.titles.country.countryInserted}}
    div(style='color: red') Προκειται για ΜΗ ΚΑΤΑΧΩΡΗΜΕΝH Χώρα
  div
    el-form-item(label='Πανεπιστήμιο' v-if='application.titles.university.name !== null && application.titles.university.name !== "other"')
      | {{application.titles.university.name}}
      el-alert(:closable='false' v-if="omotages && omotages.university && omotages.university[0].accredited === 'yes'" title='Το ίδρυμα είναι ομοταγές' type='success' show-icon='')
      el-alert(:closable='false' v-if="omotages && omotages.university && omotages.university[0].accredited === 'no'" title='Το ίδρυμα δεν είναι ομοταγές' type='error' show-icon='')
      el-alert(:closable='false' v-if="omotages && omotages.university && omotages.university[0].accredited === 'under investigation'" title='Μη κριθέν ίδρυμα' type='warning' show-icon='')
      el-alert(:closable='false' v-if="omotages && omotages.university && omotages.university[0].accredited === 'No data found for University.'" title='Δε βρέθηκαν στοιχεία για το συγκεκριμένο ίδρυμα' type='warning' show-icon='')
    el-form-item(label='Πανεπιστήμιο' v-if='application.titles.university.name === "other"')
      | {{application.titles.university.universityInserted}}
      div(style='color: red') Προκειται για ΜΗ ΚΑΤΑΧΩΡΗΜΕΝΟ Πανεπιστήμιο
  div
    el-form-item(label='Κολλέγιο', v-if='application.titles.college.name !== null && application.titles.college.name !== "other"')
      | {{application.titles.college.name}}
      el-alert(:closable='false' v-if="omotages && omotages.college && omotages.college[0] && omotages.college[0].accredited === 'yes'" title='Το κολέγιο είναι αναγνωρισμένο' type='success' show-icon='')
      el-alert(:closable='false' v-if="omotages && omotages.college && omotages.college[0] && omotages.college[0].accredited === 'no'" title='Το κολέγιο δεν είναι αναγνωρισμένο' type='error' show-icon='')
      el-alert(:closable='false' v-if="omotages && omotages.college && omotages.college[0] && omotages.college[0].accredited === 'under investigation'" title='Μη κριθέν κολέγιο' type='warning' show-icon='')
    el-form-item(label='Κολλέγιο', v-if='application.titles.college.name === "other"')
      | {{application.titles.college.collegeInserted}}
      div(style='color: red') Προκειται για ΜΗ ΚΑΤΑΧΩΡΗΜΕΝΟ Κολλέγιο
  div
    el-form-item(label='Σχολή' v-if='application.titles.faculty.name !== null && application.titles.faculty.name !== "other"')
      | {{application.titles.faculty.name}}
      el-alert(:closable='false' v-if="omotages && omotages.faculty && omotages.faculty[0] && omotages.faculty[0].accredited === 'yes'" title='Η σχολή είναι αναγνωρισμένη' type='success' show-icon='')
      el-alert(:closable='false' v-if="omotages && omotages.faculty && omotages.faculty[0] && omotages.faculty[0].accredited === 'no'" title='Η σχολή δεν είναι αναγνωρισμένη' type='error' show-icon='')
      el-alert(:closable='false' v-if="omotages && omotages.faculty && omotages.faculty[0] && omotages.faculty[0].accredited === 'under investigation'" title='Μη κριθείσα σχολή' type='warning' show-icon='')
    el-form-item(label='Σχολή', v-if='application.titles.faculty.name === "other"')
      | {{application.titles.faculty.facultyInserted}}
      div(style='color: red') Προκειται για ΜΗ ΚΑΤΑΧΩΡΗΜΕΝΗ ΣΧΟΛΗ
  div
    el-form-item(label='Τμήμα' v-if='application.titles.department.name !== null && application.titles.department.name !== "other"')
      | {{application.titles.department.name}}
      el-alert(:closable='false' v-if="omotages && omotages.department && omotages.department[0] && omotages.department[0].accredited === 'yes'" title='Το τμήμα είναι αναγνωρισμένο' type='success' show-icon='')
      el-alert(:closable='false' v-if="omotages && omotages.department && omotages.department[0] && omotages.department[0].accredited === 'no' " title='Το τμήμα δεν είναι αναγνωρισμένο' type='error' show-icon='')
      el-alert(:closable='false' v-if="omotages && omotages.department && omotages.department[0] && omotages.department[0].accredited === 'under investigation'" title='Μη κριθέν τμήμα' type='warning' show-icon='')
    el-form-item(label='Τμήμα', v-if='application.titles.department.name === "other"')
      | {{application.titles.department.departmentInserted}}
      div(style='color: red') Προκειται για ΜΗ ΚΑΤΑΧΩΡΗΜΕΝΟ Τμήμα
  hr
  el-form-item(label='Τίτλος Σπουδών')
    | {{application.titles.certificationTitle}}
  div
    el-form-item(label='Πιστωτικές Μονάδες')
      | {{application.titles.credits}}
    el-form-item(label='Διάρκεια Σπουδών')
      | {{application.titles.durationOfStudies}}
    el-form-item(label='Συνυποβολή Τίτλου', v-show="application.degreeType === 'bachelor'")
      el-checkbox(label='Επιθυμώ', name='synektimisi', v-model='application.consideration', disabled)
  div
    el-form-item(label='Ημέρ. Εγγραφής')
      | {{application.titles.dateOfRegistration}}
    el-form-item(label='Ημερ. Αποφοίτησης')
      | {{application.titles.dateOfGraduation}}
  div
    el-form-item(label='Βαθμός πτυχίου')
      | {{application.grade}}
    el-form-item(label='Χαρακτηρισμός')
      | {{application.grade_description}}
  hr
  el-form-item(label='Οι σπουδές έγιναν')
    el-switch(v-model="application.titles.studiesInMoreUniversities", :disabled='true', active-text="σε περισσότερα Πανεπιστήμια",
      inactive-text="σε ένα Πανεπιστήμιο")
  div(v-show='application.titles.studiesInMoreUniversities')
    div(v-for="(additionalUni, index) in application.titles.additionalUniversities")
      el-form-item(label='Πανεπιστήμιο' v-show="additionalUni.university != null")
        | {{additionalUni.university}}
      el-form-item(label='Μονάδες'  v-show="additionalUni.credits != null")
        | {{additionalUni.credits}}
  div(v-if="application.degreeType === 'bachelor'")
    hr
    el-alert(:closable='false' v-if="application.correspondence==false" title='Eπιλογή ΜΟΝΟ Ισοτιμίας' type='warning' show-icon)
    br
    el-form-item(label='Αναγνώριση τίτλου με')
      | {{isConsideration}}
    div(v-if="application.correspondence")
      el-form-item(label='Τμήμα Πανεπιστημίου',
      v-if="application.recognitionWith === 'aei' || application.recognitionWith === 'aeiAndTei'")
        | {{application.titlesCorrespondence.universityDepartment.name}}
      //- el-form-item(label='Τμήμα ΤΕΙ',
      //- v-if="application.recognitionWith === 'tei' || application.recognitionWith === 'aeiAndTei'")
      //-   | {{application.titlesCorrespondence.TEIDepartment.name}}
  el-button(type='primary' icon='el-icon-search' size='small' @click='listAllDepartments()' v-if='this.activeRole === "PreChecker"') Λίστα Ελλ. Ιδρυμάτων
  el-dialog(title='Λίστα Ελληνικών Ιδρυμάτων προς Αντιστοίχιση', :visible.sync='showUniList', width='60%')
    el-table(:data='allDepartments' style='width: 100%' stripe border highlight-current-row v-loading='loadingDepts' height='350')
      el-table-column(label='Ίδρυμα' width='300')
        template(slot-scope='scope')
          i.el-icon-news
          span(style='margin-left: 10px') {{ scope.row.institution_name }}
      el-table-column(label='Τμήμα' width='350')
        template(slot-scope='scope')
          i.el-icon-management
          span(style='margin-left: 10px') {{ scope.row.department_name }}
</template>

<script>

import config from '../../config.js'
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
  props: ['application', 'omotages'],
  data () {
    return {
      showUniList: false,
      allDepartments: [],
      // allDepartments: [
      //   {
      //     'departmentInstitution': 'ΑΚΑΔΗΜΙΕΣ ΕΜΠΟΡΙΚΟΥ ΝΑΥΤΙΚΟΥ',
      //     'departmentID': 817,
      //     'departmentName': 'ΣΧΟΛΗ ΠΛΟΙΑΡΧΩΝ'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΚΑΔΗΜΙΕΣ ΕΜΠΟΡΙΚΟΥ ΝΑΥΤΙΚΟΥ',
      //     'departmentID': 818,
      //     'departmentName': 'ΣΧΟΛΗ ΜΗΧΑΝΙΚΩΝ'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΝΩΤΑΤΗ ΕΚΚΛΗΣΙΑΣΤΙΚΗ ΑΚΑΔΗΜΙΑ ΑΘΗΝΩΝ',
      //     'departmentID': 413,
      //     'departmentName': 'ΠΡΟΓΡΑΜΜΑ ΙΕΡΑΤΙΚΩΝ ΣΠΟΥΔΩΝ ΑΘΗΝΑΣ'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΝΩΤΑΤΗ ΣΧΟΛΗ ΚΑΛΩΝ ΤΕΧΝΩΝ',
      //     'departmentID': 384,
      //     'departmentName': 'ΘΕΩΡΙΑΣ ΚΑΙ ΙΣΤΟΡΙΑΣ ΤΗΣ ΤΕΧΝΗΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΝΩΤΑΤΗ ΣΧΟΛΗ ΚΑΛΩΝ ΤΕΧΝΩΝ',
      //     'departmentID': '1674',
      //     'departmentName': 'ΕΙΚΑΣΤΙΚΩΝ ΤΕΧΝΩΝ'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΝΩΤΑΤΗ ΣΧΟΛΗ ΚΑΛΩΝ ΤΕΧΝΩΝ',
      //     'departmentID': '1675',
      //     'departmentName': 'ΘΕΩΡΙΑΣ ΚΑΙ ΙΣΤΟΡΙΑΣ ΤΗΣ ΤΕΧΝΗΣ'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΝΩΤΑΤΗ ΣΧΟΛΗ ΠΑΙΔΑΓΩΓΙΚΗΣ & ΤΕΧΝΟΛΟΓΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ',
      //     'departmentID': 477,
      //     'departmentName': 'ΕΚΠΑΙΔΕΥΤΙΚΩΝ ΜΗΧΑΝΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ '
      //   },
      //   {
      //     'departmentInstitution': 'ΑΝΩΤΑΤΗ ΣΧΟΛΗ ΠΑΙΔΑΓΩΓΙΚΗΣ & ΤΕΧΝΟΛΟΓΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ',
      //     'departmentID': 497,
      //     'departmentName': 'ΕΚΠΑΙΔΕΥΤΙΚΩΝ ΗΛΕΚΤΡΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ ΚΑΙ ΕΚΠΑΙΔΕΥΤΙΚΩΝ  ΗΛΕΚΤΡΟΝΙΚΩΝ ΜΗΧΑΝΙΚΩΝ - ΕΚΠΑΙΔΕΥΤΙΚΩΝ ΗΛΕΚΤΡΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΝΩΤΑΤΗ ΣΧΟΛΗ ΠΑΙΔΑΓΩΓΙΚΗΣ & ΤΕΧΝΟΛΟΓΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ',
      //     'departmentID': 507,
      //     'departmentName': 'ΕΚΠΑΙΔΕΥΤΙΚΩΝ ΗΛΕΚΤΡΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ ΚΑΙ ΕΚΠΑΙΔΕΥΤΙΚΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΜΗΧΑΝΙΚΩΝ- ΕΚΠΑΙΔΕΥΤΙΚΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΜΗΧΑΝΙΚΩΝ'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΝΩΤΑΤΗ ΣΧΟΛΗ ΠΑΙΔΑΓΩΓΙΚΗΣ & ΤΕΧΝΟΛΟΓΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ',
      //     'departmentID': 776,
      //     'departmentName': 'ΕΚΠΑΙΔΕΥΤΙΚΩΝ ΠΟΛΙΤΙΚΩΝ ΜΗΧΑΝΙΚΩΝ'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΝΩΤΕΡΕΣ ΣΧΟΛΕΣ ΤΟΥΡΙΣΤΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ (Α.Σ.Τ.Ε.)',
      //     'departmentID': 613,
      //     'departmentName': 'ΑΝΩΤΕΡΗ ΣΧΟΛΗ ΤΟΥΡΙΣΤΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ ΡΟΔΟΥ (ΑΣΤΕΡ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΝΩΤΕΡΕΣ ΣΧΟΛΕΣ ΤΟΥΡΙΣΤΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ (Α.Σ.Τ.Ε.)',
      //     'departmentID': 614,
      //     'departmentName': 'ΑΝΩΤΕΡΗ ΣΧΟΛΗ ΤΟΥΡΙΣΤΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ ΚΡΗΤΗΣ (ΑΣΤΕΚ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 103,
      //     'departmentName': 'ΘΕΟΛΟΓΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 107,
      //     'departmentName': 'ΚΟΙΝΩΝΙΚΗΣ ΘΕΟΛΟΓΙΑΣ ΚΑΙ ΧΡΙΣΤΙΑΝΙΚΟΥ ΠΟΛΙΤΙΣΜΟΥ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 111,
      //     'departmentName': 'ΦΙΛΟΛΟΓΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 112,
      //     'departmentName': 'ΙΣΤΟΡΙΑΣ ΚΑΙ ΑΡΧΑΙΟΛΟΓΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 119,
      //     'departmentName': 'ΝΟΜΙΚΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 120,
      //     'departmentName': 'ΦΙΛΟΣΟΦΙΑΣ ΚΑΙ ΠΑΙΔΑΓΩΓΙΚΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 129,
      //     'departmentName': 'ΑΓΓΛΙΚΗΣ ΓΛΩΣΣΑΣ ΚΑΙ ΦΙΛΟΛΟΓΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 133,
      //     'departmentName': 'ΓΑΛΛΙΚΗΣ ΓΛΩΣΣΑΣ ΚΑΙ ΦΙΛΟΛΟΓΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 134,
      //     'departmentName': 'ΕΠΙΣΤΗΜΩΝ ΠΡΟΣΧΟΛΙΚΗΣ ΑΓΩΓΗΣ ΚΑΙ ΕΚΠΑΙΔΕΥΣΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 137,
      //     'departmentName': 'ΓΕΡΜΑΝΙΚΗΣ ΓΛΩΣΣΑΣ ΚΑΙ ΦΙΛΟΛΟΓΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 139,
      //     'departmentName': 'ΙΤΑΛΙΚΗΣ ΓΛΩΣΣΑΣ ΚΑΙ ΦΙΛΟΛΟΓΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 140,
      //     'departmentName': 'ΠΑΙΔΑΓΩΓΙΚΟ ΔΗΜΟΤΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 147,
      //     'departmentName': 'ΔΗΜΟΣΙΟΓΡΑΦΙΑΣ ΚΑΙ ΜΕΣΩΝ ΜΑΖΙΚΗΣ ΕΠΙΚΟΙΝΩΝΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 163,
      //     'departmentName': 'ΚΙΝΗΜΑΤΟΓΡΑΦΟΥ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 168,
      //     'departmentName': 'ΘΕΑΤΡΟΥ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 172,
      //     'departmentName': 'ΨΥΧΟΛΟΓΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 203,
      //     'departmentName': 'ΠΟΛΙΤΙΚΩΝ ΜΗΧΑΝΙΚΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 211,
      //     'departmentName': 'ΜΗΧΑΝΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 219,
      //     'departmentName': 'ΗΛΕΚΤΡΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ ΚΑΙ ΜΗΧΑΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 227,
      //     'departmentName': 'ΑΓΡΟΝΟΜΩΝ ΚΑΙ ΤΟΠΟΓΡΑΦΩΝ ΜΗΧΑΝΙΚΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 233,
      //     'departmentName': 'ΑΡΧΙΤΕΚΤΟΝΩΝ ΜΗΧΑΝΙΚΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 237,
      //     'departmentName': 'ΧΗΜΙΚΩΝ ΜΗΧΑΝΙΚΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 245,
      //     'departmentName': 'ΜΑΘΗΜΑΤΙΚΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 255,
      //     'departmentName': 'ΦΥΣΙΚΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 265,
      //     'departmentName': 'ΧΗΜΕΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 273,
      //     'departmentName': 'ΓΕΩΠΟΝΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ) – ΑΠΘ'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 275,
      //     'departmentName': 'ΔΑΣΟΛΟΓΙΑΣ ΚΑΙ ΦΥΣΙΚΟΥ ΠΕΡΙΒΑΛΛΟΝΤΟΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 279,
      //     'departmentName': 'ΒΙΟΛΟΓΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 285,
      //     'departmentName': 'ΓΕΩΛΟΓΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 291,
      //     'departmentName': 'ΦΑΡΜΑΚΕΥΤΙΚΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 297,
      //     'departmentName': 'ΙΑΤΡΙΚΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 305,
      //     'departmentName': 'ΟΔΟΝΤΙΑΤΡΙΚΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 307,
      //     'departmentName': 'ΚΤΗΝΙΑΤΡΙΚΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 311,
      //     'departmentName': 'ΟΙΚΟΝΟΜΙΚΩΝ ΕΠΙΣΤΗΜΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ) – ΑΠΘ'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 338,
      //     'departmentName': 'ΠΛΗΡΟΦΟΡΙΚΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 357,
      //     'departmentName': 'ΠΟΛΙΤΙΚΩΝ ΕΠΙΣΤΗΜΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 363,
      //     'departmentName': 'ΜΗΧΑΝΙΚΩΝ ΧΩΡΟΤΑΞΙΑΣ ΚΑΙ ΑΝΑΠΤΥΞΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 402,
      //     'departmentName': 'ΕΠΙΣΤΗΜΗΣ ΦΥΣΙΚΗΣ ΑΓΩΓΗΣ ΚΑΙ ΑΘΛΗΤΙΣΜΟΥ (ΣΕΡΡΕΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 403,
      //     'departmentName': 'ΕΠΙΣΤΗΜΗΣ ΦΥΣΙΚΗΣ ΑΓΩΓΗΣ ΚΑΙ ΑΘΛΗΤΙΣΜΟΥ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 406,
      //     'departmentName': 'ΜΟΥΣΙΚΩΝ ΣΠΟΥΔΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΡΙΣΤΟΤΕΛΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΟΝΙΚΗΣ',
      //     'departmentID': 780,
      //     'departmentName': 'ΘΕΟΛΟΓΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ) - ΜΟΥΣΟΥΛΜΑΝΙΚΩΝ ΣΠΟΥΔΩΝ'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΣΤΥΝΟΜΙΚΕΣ ΣΧΟΛΕΣ',
      //     'departmentID': 869,
      //     'departmentName': 'ΑΞΙΩΜΑΤΙΚΩΝ ΕΛΛΗΝΙΚΗΣ ΑΣΤΥΝΟΜΙΑΣ (ΜΟΝΟ ΓΙΑ ΠΟΛΙΤΕΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΣΤΥΝΟΜΙΚΕΣ ΣΧΟΛΕΣ',
      //     'departmentID': 870,
      //     'departmentName': 'ΑΣΤΥΦΥΛΑΚΩΝ (ΜΟΝΟ ΓΙΑ ΠΟΛΙΤΕΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΑΣΤΥΝΟΜΙΚΕΣ ΣΧΟΛΕΣ',
      //     'departmentID': 872,
      //     'departmentName': 'ΑΞΙΩΜΑΤΙΚΩΝ ΕΛΛΗΝΙΚΗΣ ΑΣΤΥΝΟΜΙΑΣ (ΜΟΝΟ ΓΙΑ ΑΣΤΥΝΟΜΙΚΟΥΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΓΕΩΠΟΝΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 323,
      //     'departmentName': 'ΕΠΙΣΤΗΜΗΣ ΦΥΤΙΚΗΣ ΠΑΡΑΓΩΓΗΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΓΕΩΠΟΝΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 324,
      //     'departmentName': 'ΕΠΙΣΤΗΜΗΣ ΖΩΙΚΗΣ ΠΑΡΑΓΩΓΗΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΓΕΩΠΟΝΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 325,
      //     'departmentName': 'ΒΙΟΤΕΧΝΟΛΟΓΙΑΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΓΕΩΠΟΝΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 326,
      //     'departmentName': 'ΑΓΡΟΤΙΚΗΣ ΟΙΚΟΝΟΜΙΑΣ ΚΑΙ ΑΝΑΠΤΥΞΗΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΓΕΩΠΟΝΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 327,
      //     'departmentName': 'ΑΞΙΟΠΟΙΗΣΗΣ ΦΥΣΙΚΩΝ ΠΟΡΩΝ ΚΑΙ ΓΕΩΡΓΙΚΗΣ ΜΗΧΑΝΙΚΗΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΓΕΩΠΟΝΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 328,
      //     'departmentName': 'ΕΠΙΣΤΗΜΗΣ ΤΡΟΦΙΜΩΝ ΚΑΙ ΔΙΑΤΡΟΦΗΣ ΤΟΥ ΑΝΘΡΩΠΟΥ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΓΕΩΠΟΝΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 1061,
      //     'departmentName': 'ΔΑΣΟΛΟΓΙΑΣ ΚΑΙ ΔΙΑΧΕΙΡΙΣΗΣ ΦΥΣΙΚΟΥ ΠΕΡΙΒΑΛΛΟΝΤΟΣ (ΚΑΡΠΕΝΗΣΙ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΓΕΩΠΟΝΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 1063,
      //     'departmentName': 'ΔΙΟΙΚΗΣΗΣ ΓΕΩΡΓΙΚΩΝ ΕΠΙΧΕΙΡΗΣΕΩΝ ΚΑΙ ΣΥΣΤΗΜΑΤΩΝ ΕΦΟΔΙΑΣΜΟΥ (ΘΗΒΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΓΕΩΠΟΝΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 1064,
      //     'departmentName': 'ΠΕΡΙΦΕΡΕΙΑΚΗΣ ΚΑΙ ΟΙΚΟΝΟΜΙΚΗΣ ΑΝΑΠΤΥΞΗΣ (ΑΜΦΙΣΣΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ',
      //     'departmentID': 97,
      //     'departmentName': 'ΟΙΚΟΝΟΜΙΚΩΝ ΕΠΙΣΤΗΜΩΝ (ΚΟΜΟΤΗΝΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ',
      //     'departmentID': 106,
      //     'departmentName': 'ΕΛΛΗΝΙΚΗΣ ΦΙΛΟΛΟΓΙΑΣ (ΚΟΜΟΤΗΝΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ',
      //     'departmentID': 108,
      //     'departmentName': 'ΙΣΤΟΡΙΑΣ ΚΑΙ ΕΘΝΟΛΟΓΙΑΣ (ΚΟΜΟΤΗΝΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ',
      //     'departmentID': 121,
      //     'departmentName': 'ΝΟΜΙΚΗΣ (ΚΟΜΟΤΗΝΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ',
      //     'departmentID': 142,
      //     'departmentName': 'ΠΑΙΔΑΓΩΓΙΚΟ ΔΗΜΟΤΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ (ΑΛΕΞΑΝΔΡΟΥΠΟΛΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ',
      //     'departmentID': 160,
      //     'departmentName': 'ΕΠΙΣΤΗΜΩΝ ΤΗΣ ΕΚΠΑΙΔΕΥΣΗΣ ΣΤΗΝ ΠΡΟΣΧΟΛΙΚΗ ΗΛΙΚΙΑ (ΑΛΕΞΑΝΔΡΟΥΠΟΛΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ',
      //     'departmentID': 186,
      //     'departmentName': 'ΓΛΩΣΣΑΣ, ΦΙΛΟΛΟΓΙΑΣ ΚΑΙ ΠΟΛΙΤΙΣΜΟΥ ΠΑΡΕΥΞΕΙΝΙΩΝ ΧΩΡΩΝ (ΚΟΜΟΤΗΝΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ',
      //     'departmentID': 207,
      //     'departmentName': 'ΠΟΛΙΤΙΚΩΝ ΜΗΧΑΝΙΚΩΝ (ΞΑΝΘΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ',
      //     'departmentID': 212,
      //     'departmentName': 'ΔΑΣΟΛΟΓΙΑΣ ΚΑΙ ΔΙΑΧΕΙΡΙΣΗΣ ΠΕΡΙΒΑΛΛΟΝΤΟΣ ΚΑΙ ΦΥΣΙΚΩΝ ΠΟΡΩΝ (ΟΡΕΣΤΙΑΔΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ',
      //     'departmentID': 223,
      //     'departmentName': 'ΗΛΕΚΤΡΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ ΚΑΙ ΜΗΧΑΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ (ΞΑΝΘΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ',
      //     'departmentID': 224,
      //     'departmentName': 'ΜΗΧΑΝΙΚΩΝ ΠΑΡΑΓΩΓΗΣ ΚΑΙ ΔΙΟΙΚΗΣΗΣ (ΞΑΝΘΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ',
      //     'departmentID': 234,
      //     'departmentName': 'ΑΡΧΙΤΕΚΤΟΝΩΝ ΜΗΧΑΝΙΚΩΝ (ΞΑΝΘΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ',
      //     'departmentID': 290,
      //     'departmentName': 'ΜΟΡΙΑΚΗΣ ΒΙΟΛΟΓΙΑΣ ΚΑΙ ΓΕΝΕΤΙΚΗΣ (ΑΛΕΞΑΝΔΡΟΥΠΟΛΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ',
      //     'departmentID': 302,
      //     'departmentName': 'ΙΑΤΡΙΚΗΣ (ΑΛΕΞΑΝΔΡΟΥΠΟΛΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ',
      //     'departmentID': 353,
      //     'departmentName': 'ΑΓΡΟΤΙΚΗΣ ΑΝΑΠΤΥΞΗΣ (ΟΡΕΣΤΙΑΔΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ',
      //     'departmentID': 373,
      //     'departmentName': 'ΠΟΛΙΤΙΚΗΣ ΕΠΙΣΤΗΜΗΣ (ΚΟΜΟΤΗΝΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ',
      //     'departmentID': 404,
      //     'departmentName': 'ΕΠΙΣΤΗΜΗΣ ΦΥΣΙΚΗΣ ΑΓΩΓΗΣ ΚΑΙ ΑΘΛΗΤΙΣΜΟΥ (ΚΟΜΟΤΗΝΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ',
      //     'departmentID': 476,
      //     'departmentName': 'ΜΗΧΑΝΙΚΩΝ ΠΕΡΙΒΑΛΛΟΝΤΟΣ (ΞΑΝΘΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ',
      //     'departmentID': 1301,
      //     'departmentName': 'ΚΟΙΝΩΝΙΚΗΣ ΕΡΓΑΣΙΑΣ (ΚΟΜΟΤΗΝΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΗΜΟΚΡΙΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΡΑΚΗΣ',
      //     'departmentID': 1302,
      //     'departmentName': 'ΚΟΙΝΩΝΙΚΗΣ ΠΟΛΙΤΙΚΗΣ (ΚΟΜΟΤΗΝΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ',
      //     'departmentID': 1601,
      //     'departmentName': 'ΟΡΓΑΝΩΣΗΣ ΚΑΙ ΔΙΟΙΚΗΣΗΣ ΕΠΙΧΕΙΡΗΣΕΩΝ (ΣΕΡΡΕΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ',
      //     'departmentID': 1602,
      //     'departmentName': 'ΟΙΚΟΝΟΜΙΚΩΝ ΕΠΙΣΤΗΜΩΝ (ΣΕΡΡΕΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ',
      //     'departmentID': 1603,
      //     'departmentName': 'ΔΙΟΙΚΗΣΗΣ ΕΦΟΔΙΑΣΤΙΚΗΣ ΑΛΥΣΙΔΑΣ (ΚΑΤΕΡΙΝΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ',
      //     'departmentID': 1604,
      //     'departmentName': 'ΛΟΓΙΣΤΙΚΗΣ ΚΑΙ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΗΣ (ΚΑΒΑΛΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ',
      //     'departmentID': 1605,
      //     'departmentName': 'ΔΙΟΙΚΗΣΗΣ ΟΡΓΑΝΙΣΜΩΝ, ΜΑΡΚΕΤΙΝΓΚ ΚΑΙ ΤΟΥΡΙΣΜΟΥ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ',
      //     'departmentID': 1606,
      //     'departmentName': 'ΛΟΓΙΣΤΙΚΗΣ ΚΑΙ ΠΛΗΡΟΦΟΡΙΑΚΩΝ ΣΥΣΤΗΜΑΤΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ',
      //     'departmentID': 1607,
      //     'departmentName': 'ΔΙΟΙΚΗΤΙΚΗΣ ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑΣ (ΚΑΒΑΛΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ',
      //     'departmentID': 1609,
      //     'departmentName': 'ΒΙΒΛΙΟΘΗΚΟΝΟΜΙΑΣ, ΑΡΧΕΙΟΝΟΜΙΑΣ ΚΑΙ ΣΥΣΤΗΜΑΤΩΝ ΠΛΗΡΟΦΟΡΗΣΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ',
      //     'departmentID': 1610,
      //     'departmentName': 'ΑΓΩΓΗΣ ΚΑΙ ΦΡΟΝΤΙΔΑΣ ΣΤΗΝ ΠΡΩΙΜΗ ΠΑΙΔΙΚΗ ΗΛΙΚΙΑ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ',
      //     'departmentID': 1613,
      //     'departmentName': 'ΕΠΙΣΤΗΜΩΝ ΔΙΑΤΡΟΦΗΣ ΚΑΙ ΔΙΑΙΤΟΛΟΓΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ',
      //     'departmentID': 1614,
      //     'departmentName': 'ΜΑΙΕΥΤΙΚΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ',
      //     'departmentID': 1615,
      //     'departmentName': 'ΒΙΟΪΑΤΡΙΚΩΝ ΕΠΙΣΤΗΜΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ',
      //     'departmentID': 1616,
      //     'departmentName': 'ΦΥΣΙΚΟΘΕΡΑΠΕΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ',
      //     'departmentID': 1617,
      //     'departmentName': 'ΝΟΣΗΛΕΥΤΙΚΗΣ (ΔΙΔΥΜΟΤΕΙΧΟ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ',
      //     'departmentID': 1618,
      //     'departmentName': 'ΝΟΣΗΛΕΥΤΙΚΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ',
      //     'departmentID': 1619,
      //     'departmentName': 'ΜΗΧΑΝΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ (ΣΕΡΡΕΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ',
      //     'departmentID': 1620,
      //     'departmentName': 'ΜΗΧΑΝΙΚΩΝ ΤΟΠΟΓΡΑΦΙΑΣ ΚΑΙ ΓΕΩΠΛΗΡΟΦΟΡΙΚΗΣ (ΣΕΡΡΕΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ',
      //     'departmentID': 1621,
      //     'departmentName': 'ΠΟΛΙΤΙΚΩΝ ΜΗΧΑΝΙΚΩΝ (ΣΕΡΡΕΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ',
      //     'departmentID': 1622,
      //     'departmentName': 'ΜΗΧΑΝΙΚΩΝ ΠΛΗΡΟΦΟΡΙΚΗΣ, ΥΠΟΛΟΓΙΣΤΩΝ ΚΑΙ ΤΗΛΕΠΙΚΟΙΝΩΝΙΩΝ (ΣΕΡΡΕΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ',
      //     'departmentID': 1623,
      //     'departmentName': 'ΜΗΧΑΝΙΚΩΝ ΠΕΡΙΒΑΛΛΟΝΤΟΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ',
      //     'departmentID': 1624,
      //     'departmentName': 'ΜΗΧΑΝΙΚΩΝ ΠΑΡΑΓΩΓΗΣ ΚΑΙ ΔΙΟΙΚΗΣΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ',
      //     'departmentID': 1625,
      //     'departmentName': 'ΜΗΧΑΝΙΚΩΝ ΠΛΗΡΟΦΟΡΙΚΗΣ ΚΑΙ ΗΛΕΚΤΡΟΝΙΚΩΝ ΣΥΣΤΗΜΑΤΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ',
      //     'departmentID': 1626,
      //     'departmentName': 'ΕΣΩΤΕΡΙΚΗΣ ΑΡΧΙΤΕΚΤΟΝΙΚΗΣ (ΣΕΡΡΕΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ',
      //     'departmentID': 1627,
      //     'departmentName': 'ΔΗΜΙΟΥΡΓΙΚΟΥ ΣΧΕΔΙΑΣΜΟΥ ΚΑΙ ΕΝΔΥΣΗΣ (ΚΙΛΚΙΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ',
      //     'departmentID': 1628,
      //     'departmentName': 'ΦΥΣΙΚΗΣ (ΚΑΒΑΛΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ',
      //     'departmentID': 1629,
      //     'departmentName': 'ΧΗΜΕΙΑΣ (ΚΑΒΑΛΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ',
      //     'departmentID': 1630,
      //     'departmentName': 'ΠΛΗΡΟΦΟΡΙΚΗΣ (ΚΑΒΑΛΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ',
      //     'departmentID': 1632,
      //     'departmentName': 'ΔΑΣΟΛΟΓΙΑΣ ΚΑΙ ΦΥΣΙΚΟΥ ΠΕΡΙΒΑΛΛΟΝΤΟΣ (ΔΡΑΜΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ',
      //     'departmentID': 1633,
      //     'departmentName': 'ΑΓΡΟΤΙΚΗΣ ΒΙΟΤΕΧΝΟΛΟΓΙΑΣ ΚΑΙ ΟΙΝΟΛΟΓΙΑΣ (ΔΡΑΜΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ',
      //     'departmentID': 1634,
      //     'departmentName': 'ΓΕΩΠΟΝΙΑΣ (ΘΕΣΣΑΛΟΝΙΚΗ) – ΔΙ.ΠΑ.Ε.'
      //   },
      //   {
      //     'departmentInstitution': 'ΔΙΕΘΝΕΣ ΠΑΝΕΠΙΣΤΗΜΙΟ ΕΛΛΑΔΟΣ',
      //     'departmentID': 1635,
      //     'departmentName': 'ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑΣ ΤΡΟΦΙΜΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 101,
      //     'departmentName': 'ΘΕΟΛΟΓΙΑΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 105,
      //     'departmentName': 'ΚΟΙΝΩΝΙΚΗΣ ΘΕΟΛΟΓΙΑΣ ΚΑΙ ΘΡΗΣΚΕΙΟΛΟΓΙΑΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 109,
      //     'departmentName': 'ΦΙΛΟΛΟΓΙΑΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 110,
      //     'departmentName': 'ΙΣΤΟΡΙΑΣ ΚΑΙ ΑΡΧΑΙΟΛΟΓΙΑΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 117,
      //     'departmentName': 'ΝΟΜΙΚΗΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 123,
      //     'departmentName': 'ΠΟΛΙΤΙΚΗΣ ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΔΗΜΟΣΙΑΣ ΔΙΟΙΚΗΣΗΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 127,
      //     'departmentName': 'ΑΓΓΛΙΚΗΣ ΓΛΩΣΣΑΣ ΚΑΙ ΦΙΛΟΛΟΓΙΑΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 128,
      //     'departmentName': 'ΠΑΙΔΑΓΩΓΙΚΟ ΔΗΜΟΤΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 131,
      //     'departmentName': 'ΓΑΛΛΙΚΗΣ ΓΛΩΣΣΑΣ ΚΑΙ ΦΙΛΟΛΟΓΙΑΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 135,
      //     'departmentName': 'ΓΕΡΜΑΝΙΚΗΣ ΓΛΩΣΣΑΣ ΚΑΙ ΦΙΛΟΛΟΓΙΑΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 146,
      //     'departmentName': 'ΘΕΑΤΡΙΚΩΝ ΣΠΟΥΔΩΝ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 148,
      //     'departmentName': 'ΕΠΙΚΟΙΝΩΝΙΑΣ ΚΑΙ ΜΕΣΩΝ ΜΑΖΙΚΗΣ ΕΝΗΜΕΡΩΣΗΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 154,
      //     'departmentName': 'ΕΚΠΑΙΔΕΥΣΗΣ ΚΑΙ ΑΓΩΓΗΣ ΣΤΗΝ ΠΡΟΣΧΟΛΙΚΗ ΗΛΙΚΙΑ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 171,
      //     'departmentName': 'ΨΥΧΟΛΟΓΙΑΣ (ΑΘΗΝΑ) - ΕΚΠΑ'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 173,
      //     'departmentName': 'ΙΣΤΟΡΙΑΣ ΚΑΙ ΦΙΛΟΣΟΦΙΑΣ ΤΗΣ ΕΠΙΣΤΗΜΗΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 182,
      //     'departmentName': 'ΙΤΑΛΙΚΗΣ ΓΛΩΣΣΑΣ ΚΑΙ ΦΙΛΟΛΟΓΙΑΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 183,
      //     'departmentName': 'ΙΣΠΑΝΙΚΗΣ ΓΛΩΣΣΑΣ ΚΑΙ ΦΙΛΟΛΟΓΙΑΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 188,
      //     'departmentName': 'ΤΟΥΡΚΙΚΩΝ ΣΠΟΥΔΩΝ ΚΑΙ ΣΥΓΧΡΟΝΩΝ ΑΣΙΑΤΙΚΩΝ ΣΠΟΥΔΩΝ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 192,
      //     'departmentName': 'ΡΩΣΙΚΗΣ ΓΛΩΣΣΑΣ ΚΑΙ ΦΙΛΟΛΟΓΙΑΣ ΚΑΙ ΣΛΑΒΙΚΩΝ ΣΠΟΥΔΩΝ (ΑΘΗΝΑ) – ΡΩΣΙΚΗΣ ΓΛΩΣΣΑΣ ΚΑΙ ΦΙΛΟΛΟΓΙΑΣ'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 243,
      //     'departmentName': 'ΜΑΘΗΜΑΤΙΚΩΝ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 253,
      //     'departmentName': 'ΦΥΣΙΚΗΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 263,
      //     'departmentName': 'ΧΗΜΕΙΑΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 277,
      //     'departmentName': 'ΒΙΟΛΟΓΙΑΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 283,
      //     'departmentName': 'ΓΕΩΛΟΓΙΑΣ ΚΑΙ ΓΕΩΠΕΡΙΒΑΛΛΟΝΤΟΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 289,
      //     'departmentName': 'ΦΑΡΜΑΚΕΥΤΙΚΗΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 295,
      //     'departmentName': 'ΙΑΤΡΙΚΗΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 303,
      //     'departmentName': 'ΟΔΟΝΤΙΑΤΡΙΚΗΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 306,
      //     'departmentName': 'ΝΟΣΗΛΕΥΤΙΚΗΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 309,
      //     'departmentName': 'ΟΙΚΟΝΟΜΙΚΩΝ ΕΠΙΣΤΗΜΩΝ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 330,
      //     'departmentName': 'ΠΛΗΡΟΦΟΡΙΚΗΣ ΚΑΙ ΤΗΛΕΠΙΚΟΙΝΩΝΙΩΝ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 401,
      //     'departmentName': 'ΕΠΙΣΤΗΜΗΣ ΦΥΣΙΚΗΣ ΑΓΩΓΗΣ ΚΑΙ ΑΘΛΗΤΙΣΜΟΥ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 408,
      //     'departmentName': 'ΜΟΥΣΙΚΩΝ ΣΠΟΥΔΩΝ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 1001,
      //     'departmentName': 'ΑΓΡΟΤΙΚΗΣ ΑΝΑΠTΥΞΗΣ, ΑΓΡΟΔΙΑΤΡΟΦΗΣ ΚΑΙ ΔΙΑΧΕΙΡΙΣΗΣ ΦΥΣΙΚΩΝ ΠΟΡΩΝ (ΨΑΧΝΑ ΕΥΒΟΙΑΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 1002,
      //     'departmentName': 'ΑΕΡΟΔΙΑΣΤΗΜΙΚΗΣ ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑΣ (ΨΑΧΝΑ ΕΥΒΟΙΑΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 1004,
      //     'departmentName': 'ΔΙΑΧΕΙΡΙΣΗΣ ΛΙΜΕΝΩΝ ΚΑΙ ΝΑΥΤΙΛΙΑΣ (ΨΑΧΝΑ ΕΥΒΟΙΑΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 1005,
      //     'departmentName': 'ΔΙΟΙΚΗΣΗΣ ΕΠΙΧΕΙΡΗΣΕΩΝ ΚΑΙ ΟΡΓΑΝΙΣΜΩΝ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 1006,
      //     'departmentName': 'ΚΟΙΝΩΝΙΟΛΟΓΙΑΣ (ΑΘΗΝΑ) - ΕΚΠΑ'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 1007,
      //     'departmentName': 'ΠΑΙΔΑΓΩΓΙΚΟ ΔΕΥΤΕΡΟΒΑΘΜΙΑΣ ΕΚΠΑΙΔΕΥΣΗΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 1008,
      //     'departmentName': 'ΤΕΧΝΟΛΟΓΙΩΝ ΨΗΦΙΑΚΗΣ ΒΙΟΜΗΧΑΝΙΑΣ (ΨΑΧΝΑ ΕΥΒΟΙΑΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 1010,
      //     'departmentName': 'ΦΙΛΟΣΟΦΙΑΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ & ΚΑΠΟΔΙΣΤΡΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 1011,
      //     'departmentName': 'ΨΗΦΙΑΚΩΝ ΤΕΧΝΩΝ ΚΑΙ ΚΙΝΗΜΑΤΟΓΡΑΦΟΥ (ΨΑΧΝΑ ΕΥΒΟΙΑΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ ΜΕΤΣΟΒΙΟ ΠΟΛΥΤΕΧΝΕΙΟ',
      //     'departmentID': 201,
      //     'departmentName': 'ΠΟΛΙΤΙΚΩΝ ΜΗΧΑΝΙΚΩΝ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ ΜΕΤΣΟΒΙΟ ΠΟΛΥΤΕΧΝΕΙΟ',
      //     'departmentID': 209,
      //     'departmentName': 'ΜΗΧΑΝΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ ΜΕΤΣΟΒΙΟ ΠΟΛΥΤΕΧΝΕΙΟ',
      //     'departmentID': 217,
      //     'departmentName': 'ΗΛΕΚΤΡΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ ΚΑΙ ΜΗΧΑΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ ΜΕΤΣΟΒΙΟ ΠΟΛΥΤΕΧΝΕΙΟ',
      //     'departmentID': 225,
      //     'departmentName': 'ΑΓΡΟΝΟΜΩΝ ΚΑΙ ΤΟΠΟΓΡΑΦΩΝ ΜΗΧΑΝΙΚΩΝ - ΜΗΧΑΝΙΚΩΝ ΓΕΩΠΛΗΡΟΦΟΡΙΚΗΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ ΜΕΤΣΟΒΙΟ ΠΟΛΥΤΕΧΝΕΙΟ',
      //     'departmentID': 229,
      //     'departmentName': 'ΝΑΥΠΗΓΩΝ ΜΗΧΑΝΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ ΜΕΤΣΟΒΙΟ ΠΟΛΥΤΕΧΝΕΙΟ',
      //     'departmentID': 231,
      //     'departmentName': 'ΑΡΧΙΤΕΚΤΟΝΩΝ ΜΗΧΑΝΙΚΩΝ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ ΜΕΤΣΟΒΙΟ ΠΟΛΥΤΕΧΝΕΙΟ',
      //     'departmentID': 235,
      //     'departmentName': 'ΧΗΜΙΚΩΝ ΜΗΧΑΝΙΚΩΝ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ ΜΕΤΣΟΒΙΟ ΠΟΛΥΤΕΧΝΕΙΟ',
      //     'departmentID': 241,
      //     'departmentName': 'ΜΗΧΑΝΙΚΩΝ ΜΕΤΑΛΛΕΙΩΝ ΜΕΤΑΛΛΟΥΡΓΩΝ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΘΝΙΚΟ ΜΕΤΣΟΒΙΟ ΠΟΛΥΤΕΧΝΕΙΟ',
      //     'departmentID': 246,
      //     'departmentName': 'ΕΦΑΡΜΟΣΜΕΝΩΝ ΜΑΘΗΜΑΤΙΚΩΝ ΚΑΙ ΦΥΣΙΚΩΝ ΕΠΙΣΤΗΜΩΝ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΛΛΗΝΙΚΟ ΑΝΟΙΚΤΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': '1665',
      //     'departmentName': 'ΔΗΜΟΣΙΑ ΔΙΟΙΚΗΣΗ'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΛΛΗΝΙΚΟ ΑΝΟΙΚΤΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': '1666',
      //     'departmentName': 'ΔΙΟΙΚΗΣΗ ΕΠΙΧΕΙΡΗΣΕΩΝ ΚΑΙ ΟΡΓΑΝΙΣΜΩΝ'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΛΛΗΝΙΚΟ ΑΝΟΙΚΤΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': '1667',
      //     'departmentName': 'ΔΙΟΙΚΗΣΗ ΤΟΥΡΙΣΜΟΥ'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΛΛΗΝΙΚΟ ΑΝΟΙΚΤΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': '1668',
      //     'departmentName': 'ΙΣΠΑΝΙΚΗ ΓΛΩΣΣΑ ΚΑΙ ΠΟΛΙΤΙΣΜΟΣ'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΛΛΗΝΙΚΟ ΑΝΟΙΚΤΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': '1669',
      //     'departmentName': 'ΠΛΗΡΟΦΟΡΙΚΗ'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΛΛΗΝΙΚΟ ΑΝΟΙΚΤΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': '1670',
      //     'departmentName': 'ΣΠΟΥΔΕΣ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΗΣ ΓΡΑΦΗΣ, ΠΡΑΚΤΙΚΗΣ ΚΑΙ ΕΡΕΥΝΑΣ'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΛΛΗΝΙΚΟ ΑΝΟΙΚΤΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': '1671',
      //     'departmentName': 'ΣΠΟΥΔΕΣ ΣΤΙΣ ΦΥΣΙΚΕΣ ΕΠΙΣΤΗΜΕΣ'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΛΛΗΝΙΚΟ ΑΝΟΙΚΤΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': '1672',
      //     'departmentName': 'ΣΠΟΥΔΕΣ ΣΤΟΝ ΕΛΛΗΝΙΚΟ ΠΟΛΙΤΙΣΜΟ'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΛΛΗΝΙΚΟ ΑΝΟΙΚΤΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': '1673',
      //     'departmentName': 'ΣΠΟΥΔΕΣ ΣΤΟΝ ΕΥΡΩΠΑΪΚΟ ΠΟΛΙΤΙΣΜΟ'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΛΛΗΝΙΚΟ ΜΕΣΟΓΕΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': 1651,
      //     'departmentName': 'ΝΟΣΗΛΕΥΤΙΚΗΣ (ΗΡΑΚΛΕΙΟ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΛΛΗΝΙΚΟ ΜΕΣΟΓΕΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': 1652,
      //     'departmentName': 'ΚΟΙΝΩΝΙΚΗΣ ΕΡΓΑΣΙΑΣ (ΗΡΑΚΛΕΙΟ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΛΛΗΝΙΚΟ ΜΕΣΟΓΕΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': 1653,
      //     'departmentName': 'ΕΠΙΣΤΗΜΩΝ ΔΙΑΤΡΟΦΗΣ ΚΑΙ ΔΙΑΙΤΟΛΟΓΙΑΣ (ΣΗΤΕΙΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΛΛΗΝΙΚΟ ΜΕΣΟΓΕΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': 1654,
      //     'departmentName': 'ΛΟΓΙΣΤΙΚΗΣ ΚΑΙ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΗΣ (ΗΡΑΚΛΕΙΟ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΛΛΗΝΙΚΟ ΜΕΣΟΓΕΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': 1655,
      //     'departmentName': 'ΔΙΟΙΚΗΣΗΣ ΕΠΙΧΕΙΡΗΣΕΩΝ ΚΑΙ ΤΟΥΡΙΣΜΟΥ (ΗΡΑΚΛΕΙΟ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΛΛΗΝΙΚΟ ΜΕΣΟΓΕΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': 1656,
      //     'departmentName': 'ΔΙΟΙΚΗΤΙΚΗΣ ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑΣ (ΑΓΙΟΣ ΝΙΚΟΛΑΟΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΛΛΗΝΙΚΟ ΜΕΣΟΓΕΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': 1657,
      //     'departmentName': 'ΓΕΩΠΟΝΙΑΣ (ΗΡΑΚΛΕΙΟ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΛΛΗΝΙΚΟ ΜΕΣΟΓΕΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': 1659,
      //     'departmentName': 'ΜΗΧΑΝΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ (ΗΡΑΚΛΕΙΟ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΛΛΗΝΙΚΟ ΜΕΣΟΓΕΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': 1660,
      //     'departmentName': 'ΗΛΕΚΤΡΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ ΚΑΙ ΜΗΧΑΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ (ΗΡΑΚΛΕΙΟ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΛΛΗΝΙΚΟ ΜΕΣΟΓΕΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': 1662,
      //     'departmentName': 'ΗΛΕΚΤΡΟΝΙΚΩΝ ΜΗΧΑΝΙΚΩΝ (ΧΑΝΙΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΕΛΛΗΝΙΚΟ ΜΕΣΟΓΕΙΑΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': 1664,
      //     'departmentName': 'ΜΟΥΣΙΚΗΣ ΤΕΧΝΟΛΟΓΙΑΣ ΚΑΙ ΑΚΟΥΣΤΙΚΗΣ (ΡΕΘΥΜΝΟ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΙΟΝΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': 145,
      //     'departmentName': 'ΙΣΤΟΡΙΑΣ (ΚΕΡΚΥΡΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΙΟΝΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': 342,
      //     'departmentName': 'ΑΡΧΕΙΟΝΟΜΙΑΣ, ΒΙΒΛΙΟΘΗΚΟΝΟΜΙΑΣ ΚΑΙ ΜΟΥΣΕΙΟΛΟΓΙΑΣ (ΚΕΡΚΥΡΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΙΟΝΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': 366,
      //     'departmentName': 'ΠΛΗΡΟΦΟΡΙΚΗΣ (ΚΕΡΚΥΡΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΙΟΝΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': 367,
      //     'departmentName': 'ΤΕΧΝΩΝ ΗΧΟΥ ΚΑΙ ΕΙΚΟΝΑΣ (ΚΕΡΚΥΡΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΙΟΝΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': 385,
      //     'departmentName': 'ΞΕΝΩΝ ΓΛΩΣΣΩΝ ΜΕΤΑΦΡΑΣΗΣ ΚΑΙ ΔΙΕΡΜΗΝΕΙΑΣ (ΚΕΡΚΥΡΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΙΟΝΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': 407,
      //     'departmentName': 'ΜΟΥΣΙΚΩΝ ΣΠΟΥΔΩΝ (ΚΕΡΚΥΡΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΙΟΝΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': 1452,
      //     'departmentName': 'ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑΣ ΤΡΟΦΙΜΩΝ (ΑΡΓΟΣΤΟΛΙ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΙΟΝΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': 1453,
      //     'departmentName': 'ΠΕΡΙΒΑΛΛΟΝΤΟΣ (ΖΑΚΥΝΘΟΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΙΟΝΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': 1455,
      //     'departmentName': 'ΤΟΥΡΙΣΜΟΥ (ΚΕΡΚΥΡΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΙΟΝΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': 1456,
      //     'departmentName': 'ΨΗΦΙΑΚΩΝ ΜΕΣΩΝ ΚΑΙ ΕΠΙΚΟΙΝΩΝΙΑΣ (ΑΡΓΟΣΤΟΛΙ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΛΙΜΕΝΙΚΟ ΣΩΜΑ - ΕΛΛΗΝΙΚΗ ΑΚΤΟΦΥΛΑΚΗ',
      //     'departmentID': 881,
      //     'departmentName': 'ΣΧΟΛΗ ΔΟΚΙΜΩΝ ΣΗΜΑΙΟΦΟΡΩΝ ΛΙΜΕΝΙΚΟΥ ΣΩΜΑΤΟΣ - ΕΛΛΗΝΙΚΗΣ ΑΚΤΟΦΥΛΑΚΗΣ (Σ.Δ.Σ.Λ.Σ. - ΕΛ.ΑΚΤ.) (ΜΟΝΟ ΓΙΑ ΠΟΛΙΤΕΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΛΙΜΕΝΙΚΟ ΣΩΜΑ - ΕΛΛΗΝΙΚΗ ΑΚΤΟΦΥΛΑΚΗ',
      //     'departmentID': 882,
      //     'departmentName': 'ΣΧΟΛΗ ΔΟΚΙΜΩΝ ΛΙΜΕΝΟΦΥΛΑΚΩΝ'
      //   },
      //   {
      //     'departmentInstitution': 'ΛΙΜΕΝΙΚΟ ΣΩΜΑ - ΕΛΛΗΝΙΚΗ ΑΚΤΟΦΥΛΑΚΗ',
      //     'departmentID': 883,
      //     'departmentName': 'ΣΧΟΛΗ ΔΟΚΙΜΩΝ ΣΗΜΑΙΟΦΟΡΩΝ ΛΙΜΕΝΙΚΟΥ ΣΩΜΑΤΟΣ - ΕΛΛΗΝΙΚΗΣ ΑΚΤΟΦΥΛΑΚΗΣ (Σ.Δ.Σ.Λ.Σ. - ΕΛ.ΑΚΤ.) (ΜΟΝΟ ΓΙΑ ΕΝ ΕΝΕΡΓΕΙΑ ΣΤΕΛΕΧΗ ΛΣ-ΕΛ.ΑΚΤ.)'
      //   },
      //   {
      //     'departmentInstitution': 'ΟΙΚΟΝΟΜΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 150,
      //     'departmentName': 'ΔΙΕΘΝΩΝ ΚΑΙ ΕΥΡΩΠΑΪΚΩΝ ΟΙΚΟΝΟΜΙΚΩΝ ΣΠΟΥΔΩΝ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΟΙΚΟΝΟΜΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 240,
      //     'departmentName': 'ΔΙΟΙΚΗΤΙΚΗΣ ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΟΙΚΟΝΟΜΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 312,
      //     'departmentName': 'ΟΙΚΟΝΟΜΙΚΗΣ ΕΠΙΣΤΗΜΗΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΟΙΚΟΝΟΜΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 313,
      //     'departmentName': 'ΟΡΓΑΝΩΣΗΣ ΚΑΙ ΔΙΟΙΚΗΣΗΣ ΕΠΙΧΕΙΡΗΣΕΩΝ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΟΙΚΟΝΟΜΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 314,
      //     'departmentName': 'ΜΑΡΚΕΤΙΝΓΚ ΚΑΙ ΕΠΙΚΟΙΝΩΝΙΑΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΟΙΚΟΝΟΜΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 329,
      //     'departmentName': 'ΣΤΑΤΙΣΤΙΚΗΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΟΙΚΟΝΟΜΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 333,
      //     'departmentName': 'ΠΛΗΡΟΦΟΡΙΚΗΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΟΙΚΟΝΟΜΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΘΗΝΩΝ',
      //     'departmentID': 347,
      //     'departmentName': 'ΛΟΓΙΣΤΙΚΗΣ ΚΑΙ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΗΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝEΠΙΣΤΗΜΙΟ ΠΕΙΡΑΙΩΣ',
      //     'departmentID': 155,
      //     'departmentName': 'ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΗΣ ΚΑΙ ΤΡΑΠΕΖΙΚΗΣ ΔΙΟΙΚΗΤΙΚΗΣ (ΠΕΙΡΑΙΑΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝEΠΙΣΤΗΜΙΟ ΠΕΙΡΑΙΩΣ',
      //     'departmentID': 157,
      //     'departmentName': 'ΝΑΥΤΙΛΙΑΚΩΝ ΣΠΟΥΔΩΝ (ΠΕΙΡΑΙΑΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝEΠΙΣΤΗΜΙΟ ΠΕΙΡΑΙΩΣ',
      //     'departmentID': 262,
      //     'departmentName': 'ΨΗΦΙΑΚΩΝ ΣΥΣΤΗΜΑΤΩΝ (ΠΕΙΡΑΙΑΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝEΠΙΣΤΗΜΙΟ ΠΕΙΡΑΙΩΣ',
      //     'departmentID': 315,
      //     'departmentName': 'ΟΙΚΟΝΟΜΙΚΗΣ ΕΠΙΣΤΗΜΗΣ (ΠΕΙΡΑΙΑΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝEΠΙΣΤΗΜΙΟ ΠΕΙΡΑΙΩΣ',
      //     'departmentID': 316,
      //     'departmentName': 'ΟΡΓΑΝΩΣΗΣ ΚΑΙ ΔΙΟΙΚΗΣΗΣ ΕΠΙΧΕΙΡΗΣΕΩΝ (ΠΕΙΡΑΙΑΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝEΠΙΣΤΗΜΙΟ ΠΕΙΡΑΙΩΣ',
      //     'departmentID': 318,
      //     'departmentName': 'ΣΤΑΤΙΣΤΙΚΗΣ ΚΑΙ ΑΣΦΑΛΙΣΤΙΚΗΣ ΕΠΙΣΤΗΜΗΣ (ΠΕΙΡΑΙΑΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝEΠΙΣΤΗΜΙΟ ΠΕΙΡΑΙΩΣ',
      //     'departmentID': 336,
      //     'departmentName': 'ΒΙΟΜΗΧΑΝΙΚΗΣ ΔΙΟΙΚΗΣΗΣ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑΣ (ΠΕΙΡΑΙΑΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝEΠΙΣΤΗΜΙΟ ΠΕΙΡΑΙΩΣ',
      //     'departmentID': 339,
      //     'departmentName': 'ΠΛΗΡΟΦΟΡΙΚΗΣ (ΠΕΙΡΑΙΑΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝEΠΙΣΤΗΜΙΟ ΠΕΙΡΑΙΩΣ',
      //     'departmentID': 355,
      //     'departmentName': 'ΔΙΕΘΝΩΝ ΚΑΙ ΕΥΡΩΠΑΪΚΩΝ ΣΠΟΥΔΩΝ (ΠΕΙΡΑΙΑΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝEΠΙΣΤΗΜΙΟ ΠΕΙΡΑΙΩΣ',
      //     'departmentID': 375,
      //     'departmentName': 'ΤΟΥΡΙΣΤΙΚΩΝ ΣΠΟΥΔΩΝ (ΠΕΙΡΑΙΑΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ',
      //     'departmentID': 143,
      //     'departmentName': 'ΠΑΙΔΑΓΩΓΙΚΟ ΔΗΜΟΤΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ (ΡΟΔΟΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ',
      //     'departmentID': 162,
      //     'departmentName': 'ΕΠΙΣΤΗΜΩΝ ΤΗΣ ΠΡΟΣΧΟΛΙΚΗΣ ΑΓΩΓΗΣ ΚΑΙ ΕΚΠΑΙΔΕΥΤΙΚΟΥ ΣΧΕΔΙΑΣΜΟΥ (ΡΟΔΟΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ',
      //     'departmentID': 167,
      //     'departmentName': 'ΚΟΙΝΩΝΙΚΗΣ ΑΝΘΡΩΠΟΛΟΓΙΑΣ ΚΑΙ ΙΣΤΟΡΙΑΣ (ΜΥΤΙΛΗΝΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ',
      //     'departmentID': 180,
      //     'departmentName': 'ΝΑΥΤΙΛΙΑΣ ΚΑΙ ΕΠΙΧΕΙΡΗΜΑΤΙΚΩΝ ΥΠΗΡΕΣΙΩΝ (ΧΙΟΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ',
      //     'departmentID': 181,
      //     'departmentName': 'ΜΕΣΟΓΕΙΑΚΩΝ ΣΠΟΥΔΩΝ (ΡΟΔΟΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ',
      //     'departmentID': 218,
      //     'departmentName': 'ΣΤΑΤΙΣΤΙΚΗΣ ΚΑΙ ΑΝΑΛΟΓΙΣΤΙΚΩΝ-ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΩΝ ΜΑΘΗΜΑΤΙΚΩΝ (ΣΑΜΟΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ',
      //     'departmentID': 222,
      //     'departmentName': 'ΜΗΧΑΝΙΚΩΝ ΟΙΚΟΝΟΜΙΑΣ ΚΑΙ ΔΙΟΙΚΗΣΗΣ (ΧΙΟΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ',
      //     'departmentID': 238,
      //     'departmentName': 'ΜΗΧΑΝΙΚΩΝ ΣΧΕΔΙΑΣΗΣ ΠΡΟΪΟΝΤΩΝ ΚΑΙ ΣΥΣΤΗΜΑΤΩΝ (ΣΥΡΟΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ',
      //     'departmentID': 252,
      //     'departmentName': 'ΜΑΘΗΜΑΤΙΚΩΝ (ΣΑΜΟΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ',
      //     'departmentID': 276,
      //     'departmentName': 'ΠΕΡΙΒΑΛΛΟΝΤΟΣ (ΜΥΤΙΛΗΝΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ',
      //     'departmentID': 310,
      //     'departmentName': 'ΓΕΩΓΡΑΦΙΑΣ (ΜΥΤΙΛΗΝΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ',
      //     'departmentID': 320,
      //     'departmentName': 'ΔΙΟΙΚΗΣΗΣ ΕΠΙΧΕΙΡΗΣΕΩΝ (ΧΙΟΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ',
      //     'departmentID': 344,
      //     'departmentName': 'ΜΗΧΑΝΙΚΩΝ ΠΛΗΡΟΦΟΡΙΑΚΩΝ ΚΑΙ ΕΠΙΚΟΙΝΩΝΙΑΚΩΝ ΣΥΣΤΗΜΑΤΩΝ (ΣΑΜΟΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ',
      //     'departmentID': 348,
      //     'departmentName': 'ΚΟΙΝΩΝΙΟΛΟΓΙΑΣ (ΜΥΤΙΛΗΝΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ',
      //     'departmentID': 354,
      //     'departmentName': 'ΠΟΛΙΤΙΣΜΙΚΗΣ ΤΕΧΝΟΛΟΓΙΑΣ ΚΑΙ ΕΠΙΚΟΙΝΩΝΙΑΣ (ΜΥΤΙΛΗΝΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ',
      //     'departmentID': 372,
      //     'departmentName': 'ΕΠΙΣΤΗΜΗΣ ΤΡΟΦΙΜΩΝ ΚΑΙ ΔΙΑΤΡΟΦΗΣ (ΛΗΜΝΟΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ',
      //     'departmentID': 612,
      //     'departmentName': 'ΟΙΚΟΝΟΜΙΚΗΣ ΚΑΙ ΔΙΟΙΚΗΣΗΣ ΤΟΥΡΙΣΜΟΥ (ΧΙΟΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΑΙΓΑΙΟΥ',
      //     'departmentID': 1391,
      //     'departmentName': 'ΩΚΕΑΝΟΓΡΑΦΙΑΣ ΚΑΙ ΘΑΛΑΣΣΙΩΝ ΒΙΟΕΠΙΣΤΗΜΩΝ (ΜΥΤΙΛΗΝΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ',
      //     'departmentID': 387,
      //     'departmentName': 'ΗΛΕΚΤΡΟΛΟΓΩΝ ΚΑΙ ΗΛΕΚΤΡΟΝΙΚΩΝ ΜΗΧΑΝΙΚΩΝ (ΑΙΓΑΛΕΩ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ',
      //     'departmentID': 388,
      //     'departmentName': 'ΜΗΧΑΝΙΚΩΝ ΒΙΟΪΑΤΡΙΚΗΣ (ΑΙΓΑΛΕΩ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ',
      //     'departmentID': 389,
      //     'departmentName': 'ΜΗΧΑΝΙΚΩΝ ΒΙΟΜΗΧΑΝΙΚΗΣ ΣΧΕΔΙΑΣΗΣ ΚΑΙ ΠΑΡΑΓΩΓΗΣ (ΑΙΓΑΛΕΩ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ',
      //     'departmentID': 390,
      //     'departmentName': 'ΜΗΧΑΝΙΚΩΝ ΠΛΗΡΟΦΟΡΙΚΗΣ ΚΑΙ ΥΠΟΛΟΓΙΣΤΩΝ (ΑΙΓΑΛΕΩ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ',
      //     'departmentID': 391,
      //     'departmentName': 'ΜΗΧΑΝΙΚΩΝ ΤΟΠΟΓΡΑΦΙΑΣ ΚΑΙ ΓΕΩΠΛΗΡΟΦΟΡΙΚΗΣ (ΑΙΓΑΛΕΩ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ',
      //     'departmentID': 392,
      //     'departmentName': 'ΜΗΧΑΝΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ (ΑΙΓΑΛΕΩ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ',
      //     'departmentID': 393,
      //     'departmentName': 'ΝΑΥΠΗΓΩΝ ΜΗΧΑΝΙΚΩΝ (ΑΙΓΑΛΕΩ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ',
      //     'departmentID': 394,
      //     'departmentName': 'ΠΟΛΙΤΙΚΩΝ ΜΗΧΑΝΙΚΩΝ (ΑΙΓΑΛΕΩ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ',
      //     'departmentID': 668,
      //     'departmentName': 'ΑΡΧΕΙΟΝΟΜΙΑΣ, ΒΙΒΛΙΟΘΗΚΟΝΟΜΙΑΣ ΚΑΙ ΣΥΣΤΗΜΑΤΩΝ ΠΛΗΡΟΦΟΡΗΣΗΣ (ΑΙΓΑΛΕΩ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ',
      //     'departmentID': 669,
      //     'departmentName': 'ΔΙΟΙΚΗΣΗΣ ΕΠΙΧΕΙΡΗΣΕΩΝ (ΑΙΓΑΛΕΩ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ',
      //     'departmentID': 670,
      //     'departmentName': 'ΔΙΟΙΚΗΣΗΣ ΤΟΥΡΙΣΜΟΥ (ΑΙΓΑΛΕΩ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ',
      //     'departmentID': 671,
      //     'departmentName': 'ΚΟΙΝΩΝΙΚΗΣ ΕΡΓΑΣΙΑΣ (ΑΙΓΑΛΕΩ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ',
      //     'departmentID': 672,
      //     'departmentName': 'ΛΟΓΙΣΤΙΚΗΣ ΚΑΙ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΗΣ (ΑΙΓΑΛΕΩ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ',
      //     'departmentID': 673,
      //     'departmentName': 'ΑΓΩΓΗΣ ΚΑΙ ΦΡΟΝΤΙΔΑΣ ΣΤΗΝ ΠΡΩΙΜΗ ΠΑΙΔΙΚΗ ΗΛΙΚΙΑ (ΙΛΙΟΝ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ',
      //     'departmentID': 674,
      //     'departmentName': 'ΓΡΑΦΙΣΤΙΚΗΣ ΚΑΙ ΟΠΤΙΚΗΣ ΕΠΙΚΟΙΝΩΝΙΑΣ (ΑΙΓΑΛΕΩ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ',
      //     'departmentID': 675,
      //     'departmentName': 'ΕΣΩΤΕΡΙΚΗΣ ΑΡΧΙΤΕΚΤΟΝΙΚΗΣ (ΑΙΓΑΛΕΩ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ',
      //     'departmentID': 676,
      //     'departmentName': 'ΣΥΝΤΗΡΗΣΗΣ ΑΡΧΑΙΟΤΗΤΩΝ ΚΑΙ ΕΡΓΩΝ ΤΕΧΝΗΣ (ΑΙΓΑΛΕΩ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ',
      //     'departmentID': 677,
      //     'departmentName': 'ΦΩΤΟΓΡΑΦΙΑΣ ΚΑΙ ΟΠΤΙΚΟΑΚΟΥΣΤΙΚΩΝ ΤΕΧΝΩΝ (ΑΙΓΑΛΕΩ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ',
      //     'departmentID': 678,
      //     'departmentName': 'ΒΙΟΪΑΤΡΙΚΩΝ ΕΠΙΣΤΗΜΩΝ (ΑΙΓΑΛΕΩ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ',
      //     'departmentID': 679,
      //     'departmentName': 'ΔΗΜΟΣΙΑΣ ΚΑΙ ΚΟΙΝΟΤΙΚΗΣ ΥΓΕΙΑΣ (ΑΙΓΑΛΕΩ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ',
      //     'departmentID': 680,
      //     'departmentName': 'ΕΡΓΟΘΕΡΑΠΕΙΑΣ (ΑΙΓΑΛΕΩ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ',
      //     'departmentID': 681,
      //     'departmentName': 'ΜΑΙΕΥΤΙΚΗΣ (ΑΙΓΑΛΕΩ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ',
      //     'departmentID': 682,
      //     'departmentName': 'ΝΟΣΗΛΕΥΤΙΚΗΣ (ΑΙΓΑΛΕΩ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ',
      //     'departmentID': 683,
      //     'departmentName': 'ΦΥΣΙΚΟΘΕΡΑΠΕΙΑΣ (ΑΙΓΑΛΕΩ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ',
      //     'departmentID': 684,
      //     'departmentName': 'ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑΣ ΤΡΟΦΙΜΩΝ (ΑΙΓΑΛΕΩ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΑΤΤΙΚΗΣ',
      //     'departmentID': 685,
      //     'departmentName': 'ΕΠΙΣΤΗΜΩΝ ΟΙΝΟΥ, ΑΜΠΕΛΟΥ ΚΑΙ ΠΟΤΩΝ (ΑΙΓΑΛΕΩ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ',
      //     'departmentID': 210,
      //     'departmentName': 'ΜΗΧΑΝΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ (ΚΟΖΑΝΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ',
      //     'departmentID': 334,
      //     'departmentName': 'ΠΑΙΔΑΓΩΓΙΚΟ ΔΗΜΟΤΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ (ΦΛΩΡΙΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ',
      //     'departmentID': 341,
      //     'departmentName': 'ΠΑΙΔΑΓΩΓΙΚΟ ΝΗΠΙΑΓΩΓΩΝ (ΦΛΩΡΙΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ',
      //     'departmentID': 1541,
      //     'departmentName': 'ΜΗΧΑΝΙΚΩΝ ΟΡΥΚΤΩΝ ΠΟΡΩΝ (ΚΟΖΑΝΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ',
      //     'departmentID': 1542,
      //     'departmentName': 'ΜΗΧΑΝΙΚΩΝ ΣΧΕΔΙΑΣΗΣ ΠΡΟΪΟΝΤΩΝ ΚΑΙ ΣΥΣΤΗΜΑΤΩΝ (ΚΟΖΑΝΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ',
      //     'departmentID': 1544,
      //     'departmentName': 'ΔΙΟΙΚΗΤΙΚΗΣ ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑΣ (ΚΟΖΑΝΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ',
      //     'departmentID': 1545,
      //     'departmentName': 'ΛΟΓΙΣΤΙΚΗΣ ΚΑΙ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΗΣ (ΚΟΖΑΝΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ',
      //     'departmentID': 1546,
      //     'departmentName': 'ΟΡΓΑΝΩΣΗΣ ΚΑΙ ΔΙΟΙΚΗΣΗΣ ΕΠΙΧΕΙΡΗΣΕΩΝ (ΓΡΕΒΕΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ',
      //     'departmentID': 1547,
      //     'departmentName': 'ΣΤΑΤΙΣΤΙΚΗΣ ΚΑΙ ΑΣΦΑΛΙΣΤΙΚΗΣ ΕΠΙΣΤΗΜΗΣ (ΓΡΕΒΕΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ',
      //     'departmentID': 1548,
      //     'departmentName': 'ΟΙΚΟΝΟΜΙΚΩΝ ΕΠΙΣΤΗΜΩΝ (ΚΑΣΤΟΡΙΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ',
      //     'departmentID': 1549,
      //     'departmentName': 'ΔΙΕΘΝΩΝ ΚΑΙ ΕΥΡΩΠΑΪΚΩΝ ΟΙΚΟΝΟΜΙΚΩΝ ΣΠΟΥΔΩΝ (ΚΟΖΑΝΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ',
      //     'departmentID': 1550,
      //     'departmentName': 'ΨΥΧΟΛΟΓΙΑΣ (ΦΛΩΡΙΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ',
      //     'departmentID': 1551,
      //     'departmentName': 'ΕΠΙΚΟΙΝΩΝΙΑΣ ΚΑΙ ΨΗΦΙΑΚΩΝ ΜΕΣΩΝ (ΚΑΣΤΟΡΙΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ',
      //     'departmentID': 1552,
      //     'departmentName': 'ΓΕΩΠΟΝΙΑΣ (ΦΛΩΡΙΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ',
      //     'departmentID': 1553,
      //     'departmentName': 'ΜΑΙΕΥΤΙΚΗΣ (ΠΤΟΛΕΜΑΪΔΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ',
      //     'departmentID': 1554,
      //     'departmentName': 'ΠΛΗΡΟΦΟΡΙΚΗΣ (ΚΑΣΤΟΡΙΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ',
      //     'departmentID': 1555,
      //     'departmentName': 'ΜΑΘΗΜΑΤΙΚΩΝ (ΚΑΣΤΟΡΙΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ',
      //     'departmentID': 1558,
      //     'departmentName': 'ΕΡΓΟΘΕΡΑΠΕΙΑΣ (ΠΤΟΛΕΜΑΪΔΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ',
      //     'departmentID': 1563,
      //     'departmentName': 'ΧΗΜΙΚΩΝ ΜΗΧΑΝΙΚΩΝ (ΚΟΖΑΝΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΔΥΤΙΚΗΣ ΜΑΚΕΔΟΝΙΑΣ',
      //     'departmentID': 1564,
      //     'departmentName': 'ΗΛΕΚΤΡΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ ΚΑΙ ΜΗΧΑΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ (ΚΟΖΑΝΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 99,
      //     'departmentName': 'ΠΛΗΡΟΦΟΡΙΚΗΣ ΚΑΙ ΤΗΛΕΠΙΚΟΙΝΩΝΙΩΝ (ΛΑΜΙΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 164,
      //     'departmentName': 'ΠΑΙΔΑΓΩΓΙΚΟ ΔΗΜΟΤΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ (ΒΟΛΟΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 166,
      //     'departmentName': 'ΠΑΙΔΑΓΩΓΙΚΟ ΠΡΟΣΧΟΛΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ (ΒΟΛΟΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 177,
      //     'departmentName': 'ΙΣΤΟΡΙΑΣ, ΑΡΧΑΙΟΛΟΓΙΑΣ ΚΑΙ ΚΟΙΝΩΝΙΚΗΣ ΑΝΘΡΩΠΟΛΟΓΙΑΣ (ΒΟΛΟΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 178,
      //     'departmentName': 'ΠΑΙΔΑΓΩΓΙΚΟ ΕΙΔΙΚΗΣ ΑΓΩΓΗΣ (ΒΟΛΟΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 208,
      //     'departmentName': 'ΠΟΛΙΤΙΚΩΝ ΜΗΧΑΝΙΚΩΝ (ΒΟΛΟΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 220,
      //     'departmentName': 'ΗΛΕΚΤΡΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ ΚΑΙ ΜΗΧΑΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ (ΒΟΛΟΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 228,
      //     'departmentName': 'ΜΗΧΑΝΙΚΩΝ ΧΩΡΟΤΑΞΙΑΣ, ΠΟΛΕΟΔΟΜΙΑΣ ΚΑΙ ΠΕΡΙΦΕΡΕΙΑΚΗΣ ΑΝΑΠΤΥΞΗΣ (ΒΟΛΟΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 236,
      //     'departmentName': 'ΑΡΧΙΤΕΚΤΟΝΩΝ ΜΗΧΑΝΙΚΩΝ (ΒΟΛΟΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 274,
      //     'departmentName': 'ΓΕΩΠΟΝΙΑΣ, ΦΥΤΙΚΗΣ ΠΑΡΑΓΩΓΗΣ ΚΑΙ ΑΓΡΟΤΙΚΟΥ ΠΕΡΙΒΑΛΛΟΝΤΟΣ (ΒΟΛΟΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 284,
      //     'departmentName': 'ΒΙΟΧΗΜΕΙΑΣ ΚΑΙ ΒΙΟΤΕΧΝΟΛΟΓΙΑΣ (ΛΑΡΙΣΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 300,
      //     'departmentName': 'ΙΑΤΡΙΚΗΣ (ΛΑΡΙΣΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 308,
      //     'departmentName': 'ΚΤΗΝΙΑΤΡΙΚΗΣ (ΚΑΡΔΙΤΣΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 332,
      //     'departmentName': 'ΜΗΧΑΝΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ (ΒΟΛΟΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 350,
      //     'departmentName': 'ΟΙΚΟΝΟΜΙΚΩΝ ΕΠΙΣΤΗΜΩΝ (ΒΟΛΟΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 360,
      //     'departmentName': 'ΓΕΩΠΟΝΙΑΣ, ΙΧΘΥΟΛΟΓΙΑΣ ΚΑΙ ΥΔΑΤΙΝΟΥ ΠΕΡΙΒΑΛΛΟΝΤΟΣ (ΒΟΛΟΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 369,
      //     'departmentName': 'ΠΛΗΡΟΦΟΡΙΚΗΣ ΜΕ ΕΦΑΡΜΟΓΕΣ ΣΤΗ ΒΙΟΪΑΤΡΙΚΗ (ΛΑΜΙΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 405,
      //     'departmentName': 'ΕΠΙΣΤΗΜΗΣ ΦΥΣΙΚΗΣ ΑΓΩΓΗΣ ΚΑΙ ΑΘΛΗΤΙΣΜΟΥ (ΤΡΙΚΑΛΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 1422,
      //     'departmentName': 'ΓΕΩΠΟΝΙΑΣ - ΑΓΡΟΤΕΧΝΟΛΟΓΙΑΣ (ΛΑΡΙΣΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 1423,
      //     'departmentName': 'ΓΛΩΣΣΙΚΩΝ ΚΑΙ ΔΙΑΠΟΛΙΤΙΣΜΙΚΩΝ ΣΠΟΥΔΩΝ (ΒΟΛΟΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 1424,
      //     'departmentName': 'ΔΑΣΟΛΟΓΙΑΣ, ΕΠΙΣΤΗΜΩΝ ΞΥΛΟΥ ΚΑΙ ΣΧΕΔΙΑΣΜΟΥ (ΚΑΡΔΙΤΣΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 1425,
      //     'departmentName': 'ΔΗΜΟΣΙΑΣ ΚΑΙ ΕΝΙΑΙΑΣ ΥΓΕΙΑΣ (ΚΑΡΔΙΤΣΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 1426,
      //     'departmentName': 'ΔΙΑΙΤΟΛΟΓΙΑΣ ΚΑΙ ΔΙΑΤΡΟΦΟΛΟΓΙΑΣ (ΤΡΙΚΑΛΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 1427,
      //     'departmentName': 'ΔΙΟΙΚΗΣΗΣ ΕΠΙΧΕΙΡΗΣΕΩΝ (ΛΑΡΙΣΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 1428,
      //     'departmentName': 'ΕΠΙΣΤΗΜΗΣ ΖΩΙΚΗΣ ΠΑΡΑΓΩΓΗΣ (ΛΑΡΙΣΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 1429,
      //     'departmentName': 'ΕΠΙΣΤΗΜΗΣ ΤΡΟΦΙΜΩΝ ΚΑΙ ΔΙΑΤΡΟΦΗΣ (ΚΑΡΔΙΤΣΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 1430,
      //     'departmentName': 'ΛΟΓΙΣΤΙΚΗΣ ΚΑΙ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΗΣ (ΛΑΡΙΣΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 1432,
      //     'departmentName': 'ΜΑΘΗΜΑΤΙΚΩΝ (ΛΑΜΙΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 1433,
      //     'departmentName': 'ΝΟΣΗΛΕΥΤΙΚΗΣ (ΛΑΡΙΣΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 1434,
      //     'departmentName': 'ΠΕΡΙΒΑΛΛΟΝΤΟΣ (ΛΑΡΙΣΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 1435,
      //     'departmentName': 'ΠΟΛΙΤΙΣΜΟΥ ΚΑΙ ΔΗΜΙΟΥΡΓΙΚΩΝ ΜΕΣΩΝ ΚΑΙ ΒΙΟΜΗΧΑΝΙΩΝ (ΒΟΛΟΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 1436,
      //     'departmentName': 'ΣΥΣΤΗΜΑΤΩΝ ΕΝΕΡΓΕΙΑΣ (ΛΑΡΙΣΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 1437,
      //     'departmentName': 'ΦΥΣΙΚΗΣ (ΛΑΜΙΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 1438,
      //     'departmentName': 'ΦΥΣΙΚΟΘΕΡΑΠΕΙΑΣ (ΛΑΜΙΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΘΕΣΣΑΛΙΑΣ',
      //     'departmentID': 1439,
      //     'departmentName': 'ΨΗΦΙΑΚΩΝ ΣΥΣΤΗΜΑΤΩΝ (ΛΑΡΙΣΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ',
      //     'departmentID': 113,
      //     'departmentName': 'ΦΙΛΟΛΟΓΙΑΣ (ΙΩΑΝΝΙΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ',
      //     'departmentID': 114,
      //     'departmentName': 'ΙΣΤΟΡΙΑΣ ΚΑΙ ΑΡΧΑΙΟΛΟΓΙΑΣ (ΙΩΑΝΝΙΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ',
      //     'departmentID': 122,
      //     'departmentName': 'ΦΙΛΟΣΟΦΙΑΣ (ΙΩΑΝΝΙΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ',
      //     'departmentID': 130,
      //     'departmentName': 'ΠΑΙΔΑΓΩΓΙΚΟ ΔΗΜΟΤΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ (ΙΩΑΝΝΙΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ',
      //     'departmentID': 156,
      //     'departmentName': 'ΠΑΙΔΑΓΩΓΙΚΟ ΝΗΠΙΑΓΩΓΩΝ (ΙΩΑΝΝΙΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ',
      //     'departmentID': 249,
      //     'departmentName': 'ΜΑΘΗΜΑΤΙΚΩΝ (ΙΩΑΝΝΙΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ',
      //     'departmentID': 259,
      //     'departmentName': 'ΦΥΣΙΚΗΣ (ΙΩΑΝΝΙΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ',
      //     'departmentID': 269,
      //     'departmentName': 'ΧΗΜΕΙΑΣ (ΙΩΑΝΝΙΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ',
      //     'departmentID': 272,
      //     'departmentName': 'ΜΗΧΑΝΙΚΩΝ ΕΠΙΣΤΗΜΗΣ ΥΛΙΚΩΝ (ΙΩΑΝΝΙΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ',
      //     'departmentID': 280,
      //     'departmentName': 'ΒΙΟΛΟΓΙΚΩΝ ΕΦΑΡΜΟΓΩΝ ΚΑΙ ΤΕΧΝΟΛΟΓΙΩΝ (ΙΩΑΝΝΙΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ',
      //     'departmentID': 301,
      //     'departmentName': 'ΙΑΤΡΙΚΗΣ (ΙΩΑΝΝΙΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ',
      //     'departmentID': 340,
      //     'departmentName': 'ΜΗΧΑΝΙΚΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ ΚΑΙ ΠΛΗΡΟΦΟΡΙΚΗΣ (ΙΩΑΝΝΙΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ',
      //     'departmentID': 345,
      //     'departmentName': 'ΟΙΚΟΝΟΜΙΚΩΝ ΕΠΙΣΤΗΜΩΝ (ΙΩΑΝΝΙΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ',
      //     'departmentID': 779,
      //     'departmentName': 'ΑΡΧΙΤΕΚΤΟΝΩΝ ΜΗΧΑΝΙΚΩΝ (ΙΩΑΝΝΙΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ',
      //     'departmentID': 1241,
      //     'departmentName': 'ΑΓΩΓΗΣ ΚΑΙ ΦΡΟΝΤΙΔΑΣ ΣΤΗΝ ΠΡΩΙΜΗ ΠΑΙΔΙΚΗ ΗΛΙΚΙΑ (ΙΩΑΝΝΙΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ',
      //     'departmentID': 1242,
      //     'departmentName': 'ΓΕΩΠΟΝΙΑΣ (ΑΡΤΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ',
      //     'departmentID': 1244,
      //     'departmentName': 'ΛΟΓΙΣΤΙΚΗΣ ΚΑΙ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΗΣ (ΠΡΕΒΕΖΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ',
      //     'departmentID': 1245,
      //     'departmentName': 'ΛΟΓΟΘΕΡΑΠΕΙΑΣ (ΙΩΑΝΝΙΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ',
      //     'departmentID': 1248,
      //     'departmentName': 'ΜΟΥΣΙΚΩΝ ΣΠΟΥΔΩΝ (ΑΡΤΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ',
      //     'departmentID': 1249,
      //     'departmentName': 'ΝΟΣΗΛΕΥΤΙΚΗΣ (ΙΩΑΝΝΙΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ',
      //     'departmentID': 1250,
      //     'departmentName': 'ΠΛΗΡΟΦΟΡΙΚΗΣ ΚΑΙ ΤΗΛΕΠΙΚΟΙΝΩΝΙΩΝ (ΑΡΤΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΙΩΑΝΝΙΝΩΝ',
      //     'departmentID': 1251,
      //     'departmentName': 'ΨΥΧΟΛΟΓΙΑΣ (ΙΩΑΝΝΙΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ',
      //     'departmentID': 115,
      //     'departmentName': 'ΦΙΛΟΛΟΓΙΑΣ (ΡΕΘΥΜΝΟ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ',
      //     'departmentID': 116,
      //     'departmentName': 'ΙΣΤΟΡΙΑΣ ΚΑΙ ΑΡΧΑΙΟΛΟΓΙΑΣ (ΡΕΘΥΜΝΟ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ',
      //     'departmentID': 132,
      //     'departmentName': 'ΠΑΙΔΑΓΩΓΙΚΟ ΔΗΜΟΤΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ (ΡΕΘΥΜΝΟ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ',
      //     'departmentID': 138,
      //     'departmentName': 'ΦΙΛΟΣΟΦΙΚΩΝ ΚΑΙ ΚΟΙΝΩΝΙΚΩΝ ΣΠΟΥΔΩΝ (ΡΕΘΥΜΝΟ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ',
      //     'departmentID': 149,
      //     'departmentName': 'ΚΟΙΝΩΝΙΟΛΟΓΙΑΣ (ΡΕΘΥΜΝΟ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ',
      //     'departmentID': 151,
      //     'departmentName': 'ΨΥΧΟΛΟΓΙΑΣ (ΡΕΘΥΜΝΟ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ',
      //     'departmentID': 158,
      //     'departmentName': 'ΠΑΙΔΑΓΩΓΙΚΟ ΠΡΟΣΧΟΛΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ (ΡΕΘΥΜΝΟ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ',
      //     'departmentID': 200,
      //     'departmentName': 'ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑΣ ΥΛΙΚΩΝ (ΗΡΑΚΛΕΙΟ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ',
      //     'departmentID': 216,
      //     'departmentName': 'ΕΠΙΣΤΗΜΗΣ ΥΠΟΛΟΓΙΣΤΩΝ (ΗΡΑΚΛΕΙΟ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ',
      //     'departmentID': 248,
      //     'departmentName': 'ΜΑΘΗΜΑΤΙΚΩΝ KAI ΕΦΑΡΜΟΣΜΕΝΩΝ ΜΑΘΗΜΑΤΙΚΩΝ (ΗΡΑΚΛΕΙΟ) - ΕΦΑΡΜΟΣΜΕΝΩΝ ΜΑΘΗΜΑΤΙΚΩΝ'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ',
      //     'departmentID': 251,
      //     'departmentName': 'ΜΑΘΗΜΑΤΙΚΩΝ KAI ΕΦΑΡΜΟΣΜΕΝΩΝ ΜΑΘΗΜΑΤΙΚΩΝ (ΗΡΑΚΛΕΙΟ) - ΜΑΘΗΜΑΤΙΚΩΝ'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ',
      //     'departmentID': 261,
      //     'departmentName': 'ΦΥΣΙΚΗΣ (ΗΡΑΚΛΕΙΟ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ',
      //     'departmentID': 270,
      //     'departmentName': 'ΧΗΜΕΙΑΣ (ΗΡΑΚΛΕΙΟ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ',
      //     'departmentID': 282,
      //     'departmentName': 'ΒΙΟΛΟΓΙΑΣ (ΗΡΑΚΛΕΙΟ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ',
      //     'departmentID': 304,
      //     'departmentName': 'ΙΑΤΡΙΚΗΣ (ΗΡΑΚΛΕΙΟ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ',
      //     'departmentID': 321,
      //     'departmentName': 'ΟΙΚΟΝΟΜΙΚΩΝ ΕΠΙΣΤΗΜΩΝ (ΡΕΘΥΜΝΟ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΡΗΤΗΣ',
      //     'departmentID': 351,
      //     'departmentName': 'ΠΟΛΙΤΙΚΗΣ ΕΠΙΣΤΗΜΗΣ (ΡΕΘΥΜΝΟ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΜΑΚΕΔΟΝΙΑΣ',
      //     'departmentID': 161,
      //     'departmentName': 'ΔΙΕΘΝΩΝ ΚΑΙ ΕΥΡΩΠΑΪΚΩΝ ΣΠΟΥΔΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΜΑΚΕΔΟΝΙΑΣ',
      //     'departmentID': 174,
      //     'departmentName': 'ΕΚΠΑΙΔΕΥΤΙΚΗΣ ΚΑΙ ΚΟΙΝΩΝΙΚΗΣ ΠΟΛΙΤΙΚΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΜΑΚΕΔΟΝΙΑΣ',
      //     'departmentID': 176,
      //     'departmentName': 'ΒΑΛΚΑΝΙΚΩΝ, ΣΛΑΒΙΚΩΝ ΚΑΙ ΑΝΑΤΟΛΙΚΩΝ ΣΠΟΥΔΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΜΑΚΕΔΟΝΙΑΣ',
      //     'departmentID': 317,
      //     'departmentName': 'ΟΙΚΟΝΟΜΙΚΩΝ ΕΠΙΣΤΗΜΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ) – ΠΑΝ. ΜΑΚΕΔ.'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΜΑΚΕΔΟΝΙΑΣ',
      //     'departmentID': 322,
      //     'departmentName': 'ΟΡΓΑΝΩΣΗΣ ΚΑΙ ΔΙΟΙΚΗΣΗΣ ΕΠΙΧΕΙΡΗΣΕΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΜΑΚΕΔΟΝΙΑΣ',
      //     'departmentID': 337,
      //     'departmentName': 'ΛΟΓΙΣΤΙΚΗΣ ΚΑΙ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΜΑΚΕΔΟΝΙΑΣ',
      //     'departmentID': 409,
      //     'departmentName': 'ΜΟΥΣΙΚΗΣ ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΤΕΧΝΗΣ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΜΑΚΕΔΟΝΙΑΣ',
      //     'departmentID': 1211,
      //     'departmentName': 'ΕΦΑΡΜΟΣΜΕΝΗΣ ΠΛΗΡΟΦΟΡΙΚΗΣ - ΕΠΙΣΤΗΜΗ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑ ΥΠΟΛΟΓΙΣΤΩΝ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΜΑΚΕΔΟΝΙΑΣ',
      //     'departmentID': 1212,
      //     'departmentName': 'ΕΦΑΡΜΟΣΜΕΝΗΣ ΠΛΗΡΟΦΟΡΙΚΗΣ - ΠΛΗΡΟΦΟΡΙΑΚΑ ΣΥΣΤΗΜΑΤΑ (ΘΕΣΣΑΛΟΝΙΚΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ',
      //     'departmentID': 102,
      //     'departmentName': 'ΦΙΛΟΣΟΦΙΑΣ (ΠΑΤΡΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ',
      //     'departmentID': 136,
      //     'departmentName': 'ΕΠΙΣΤΗΜΩΝ ΤΗΣ ΕΚΠΑΙΔΕΥΣΗΣ ΚΑΙ ΤΗΣ ΑΓΩΓΗΣ ΣΤΗΝ ΠΡΟΣΧΟΛΙΚΗ ΗΛΙΚΙΑ (ΠΑΤΡΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ',
      //     'departmentID': 169,
      //     'departmentName': 'ΘΕΑΤΡΙΚΩΝ ΣΠΟΥΔΩΝ (ΠΑΤΡΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ',
      //     'departmentID': 175,
      //     'departmentName': 'ΦΙΛΟΛΟΓΙΑΣ (ΠΑΤΡΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ',
      //     'departmentID': 205,
      //     'departmentName': 'ΠΟΛΙΤΙΚΩΝ ΜΗΧΑΝΙΚΩΝ (ΠΑΤΡΑ) – ΠΑΝ. ΠΑΤΡΩΝ'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ',
      //     'departmentID': 213,
      //     'departmentName': 'ΜΗΧΑΝΟΛΟΓΩΝ ΚΑΙ ΑΕΡΟΝΑΥΠΗΓΩΝ ΜΗΧΑΝΙΚΩΝ (ΠΑΤΡΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ',
      //     'departmentID': 215,
      //     'departmentName': 'ΜΗΧΑΝΙΚΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ ΚΑΙ ΠΛΗΡΟΦΟΡΙΚΗΣ (ΠΑΤΡΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ',
      //     'departmentID': 221,
      //     'departmentName': 'ΗΛΕΚΤΡΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑΣ ΥΠΟΛΟΓΙΣΤΩΝ (ΠΑΤΡΑ) – ΠΑΝ. ΠΑΤΡΩΝ'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ',
      //     'departmentID': 232,
      //     'departmentName': 'ΑΡΧΙΤΕΚΤΟΝΩΝ ΜΗΧΑΝΙΚΩΝ (ΠΑΤΡΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ',
      //     'departmentID': 239,
      //     'departmentName': 'ΧΗΜΙΚΩΝ ΜΗΧΑΝΙΚΩΝ (ΠΑΤΡΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ',
      //     'departmentID': 247,
      //     'departmentName': 'ΜΑΘΗΜΑΤΙΚΩΝ (ΠΑΤΡΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ',
      //     'departmentID': 257,
      //     'departmentName': 'ΦΥΣΙΚΗΣ (ΠΑΤΡΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ',
      //     'departmentID': 267,
      //     'departmentName': 'ΧΗΜΕΙΑΣ (ΠΑΤΡΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ',
      //     'departmentID': 281,
      //     'departmentName': 'ΒΙΟΛΟΓΙΑΣ (ΠΑΤΡΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ',
      //     'departmentID': 287,
      //     'departmentName': 'ΓΕΩΛΟΓΙΑΣ (ΠΑΤΡΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ',
      //     'departmentID': 288,
      //     'departmentName': 'ΕΠΙΣΤΗΜΗΣ ΤΩΝ ΥΛΙΚΩΝ (ΠΑΤΡΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ',
      //     'departmentID': 293,
      //     'departmentName': 'ΦΑΡΜΑΚΕΥΤΙΚΗΣ (ΠΑΤΡΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ',
      //     'departmentID': 299,
      //     'departmentName': 'ΙΑΤΡΙΚΗΣ (ΠΑΤΡΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ',
      //     'departmentID': 319,
      //     'departmentName': 'ΟΙΚΟΝΟΜΙΚΩΝ ΕΠΙΣΤΗΜΩΝ (ΠΑΤΡΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ',
      //     'departmentID': 352,
      //     'departmentName': 'ΔΙΟΙΚΗΣΗΣ ΕΠΙΧΕΙΡΗΣΕΩΝ (ΠΑΤΡΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ',
      //     'departmentID': 1272,
      //     'departmentName': 'ΝΟΣΗΛΕΥΤΙΚΗΣ (ΠΑΤΡΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ',
      //     'departmentID': 1273,
      //     'departmentName': 'ΦΥΣΙΚΟΘΕΡΑΠΕΙΑΣ (ΑΙΓΙΟ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ',
      //     'departmentID': 1274,
      //     'departmentName': 'ΛΟΓΟΘΕΡΑΠΕΙΑΣ (ΠΑΤΡΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ',
      //     'departmentID': 1276,
      //     'departmentName': 'ΖΩΙΚΗΣ ΠΑΡΑΓΩΓΗΣ, ΑΛΙΕΙΑΣ ΚΑΙ ΥΔΑΤΟΚΑΛΛΙΕΡΓΕΙΩΝ (ΜΕΣΟΛΟΓΓΙ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ',
      //     'departmentID': 1278,
      //     'departmentName': 'ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑΣ ΤΡΟΦΙΜΩΝ (ΑΓΡΙΝΙΟ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ',
      //     'departmentID': 1280,
      //     'departmentName': 'ΕΠΙΣΤΗΜΗΣ ΦΥΤΙΚΗΣ ΠΑΡΑΓΩΓΗΣ (ΜΕΣΟΛΟΓΓΙ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ',
      //     'departmentID': 1282,
      //     'departmentName': 'ΔΙΟΙΚΗΤΙΚΗΣ ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑΣ (ΠΑΤΡΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ',
      //     'departmentID': 1283,
      //     'departmentName': 'ΔΙΟΙΚΗΣΗΣ ΤΟΥΡΙΣΜΟΥ (ΠΑΤΡΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ',
      //     'departmentID': 1284,
      //     'departmentName': 'ΙΣΤΟΡΙΑΣ - ΑΡΧΑΙΟΛΟΓΙΑΣ (ΑΓΡΙΝΙΟ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΑΤΡΩΝ',
      //     'departmentID': 1286,
      //     'departmentName': 'ΕΠΙΣΤΗΜΩΝ ΤΗΣ ΕΚΠΑΙΔΕΥΣΗΣ ΚΑΙ ΚΟΙΝΩΝΙΚΗΣ ΕΡΓΑΣΙΑΣ (ΠΑΤΡΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ',
      //     'departmentID': 98,
      //     'departmentName': 'ΠΛΗΡΟΦΟΡΙΚΗΣ ΚΑΙ ΤΗΛΕΠΙΚΟΙΝΩΝΙΩΝ (ΤΡΙΠΟΛΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ',
      //     'departmentID': 104,
      //     'departmentName': 'ΙΣΤΟΡΙΑΣ, ΑΡΧΑΙΟΛΟΓΙΑΣ ΚΑΙ ΔΙΑΧΕΙΡΙΣΗΣ ΠΟΛΙΤΙΣΜΙΚΩΝ ΑΓΑΘΩΝ (ΚΑΛΑΜΑΤΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ',
      //     'departmentID': 187,
      //     'departmentName': 'ΚΟΙΝΩΝΙΚΗΣ ΚΑΙ ΕΚΠΑΙΔΕΥΤΙΚΗΣ ΠΟΛΙΤΙΚΗΣ (ΚΟΡΙΝΘΟΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ',
      //     'departmentID': 189,
      //     'departmentName': 'ΦΙΛΟΛΟΓΙΑΣ (ΚΑΛΑΜΑΤΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ',
      //     'departmentID': 190,
      //     'departmentName': 'ΝΟΣΗΛΕΥΤΙΚΗΣ (ΤΡΙΠΟΛΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ',
      //     'departmentID': 361,
      //     'departmentName': 'ΟΙΚΟΝΟΜΙΚΩΝ ΕΠΙΣΤΗΜΩΝ (ΤΡΙΠΟΛΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ',
      //     'departmentID': 362,
      //     'departmentName': 'ΘΕΑΤΡΙΚΩΝ ΣΠΟΥΔΩΝ (ΝΑΥΠΛΙΟ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ',
      //     'departmentID': 400,
      //     'departmentName': 'ΟΡΓΑΝΩΣΗΣ ΚΑΙ ΔΙΑΧΕΙΡΙΣΗΣ ΑΘΛΗΤΙΣΜΟΥ (ΣΠΑΡΤΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ',
      //     'departmentID': 411,
      //     'departmentName': 'ΠΟΛΙΤΙΚΗΣ ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΔΙΕΘΝΩΝ ΣΧΕΣΕΩΝ (ΚΟΡΙΝΘΟΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ',
      //     'departmentID': 1511,
      //     'departmentName': 'ΓΕΩΠΟΝΙΑΣ (ΚΑΛΑΜΑΤΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ',
      //     'departmentID': 1512,
      //     'departmentName': 'ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑΣ ΤΡΟΦΙΜΩΝ (ΚΑΛΑΜΑΤΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ',
      //     'departmentID': 1513,
      //     'departmentName': 'ΛΟΓΙΣΤΙΚΗΣ ΚΑΙ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΗΣ (ΚΑΛΑΜΑΤΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ',
      //     'departmentID': 1514,
      //     'departmentName': 'ΔΙΟΙΚΗΣΗΣ ΕΠΙΧΕΙΡΗΣΕΩΝ ΚΑΙ ΟΡΓΑΝΙΣΜΩΝ (ΚΑΛΑΜΑΤΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ',
      //     'departmentID': 1515,
      //     'departmentName': 'ΛΟΓΟΘΕΡΑΠΕΙΑΣ (ΚΑΛΑΜΑΤΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ',
      //     'departmentID': 1516,
      //     'departmentName': 'ΕΠΙΣΤΗΜΗΣ ΔΙΑΤΡΟΦΗΣ ΚΑΙ ΔΙΑΙΤΟΛΟΓΙΑΣ (ΚΑΛΑΜΑΤΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ',
      //     'departmentID': 1517,
      //     'departmentName': 'ΠΑΡΑΣΤΑΤΙΚΩΝ ΚΑΙ ΨΗΦΙΑΚΩΝ ΤΕΧΝΩΝ (ΝΑΥΠΛΙΟ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ',
      //     'departmentID': 1518,
      //     'departmentName': 'ΔΙΟΙΚΗΤΙΚΗΣ ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΤΕΧΝΟΛΟΓΙΑΣ (ΤΡΙΠΟΛΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ',
      //     'departmentID': 1519,
      //     'departmentName': 'ΨΗΦΙΑΚΩΝ ΣΥΣΤΗΜΑΤΩΝ (ΣΠΑΡΤΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ',
      //     'departmentID': 1520,
      //     'departmentName': 'ΦΥΣΙΚΟΘΕΡΑΠΕΙΑΣ (ΣΠΑΡΤΗ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ',
      //     'departmentID': 1522,
      //     'departmentName': 'ΗΛΕΚΤΡΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ ΚΑΙ ΜΗΧΑΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ (ΠΑΤΡΑ) – ΠΑΝ. ΠΕΛ/ΝΗΣΟΥ'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ',
      //     'departmentID': 1523,
      //     'departmentName': 'ΜΗΧΑΝΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ (ΠΑΤΡΑ) – ΠΑΝ. ΠΕΛ/ΝΗΣΟΥ'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΕΠΙΣΤΗΜΙΟ ΠΕΛΟΠΟΝΝΗΣΟΥ',
      //     'departmentID': 1524,
      //     'departmentName': 'ΠΟΛΙΤΙΚΩΝ ΜΗΧΑΝΙΚΩΝ (ΠΑΤΡΑ) – ΠΑΝ. ΠΕΛ/ΝΗΣΟΥ'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΟΙΝΩΝΙΚΩΝ ΚΑΙ ΠΟΛΙΤΙΚΩΝ ΕΠΙΣΤΗΜΩΝ',
      //     'departmentID': 124,
      //     'departmentName': 'ΔΗΜΟΣΙΑΣ ΔΙΟΙΚΗΣΗΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΟΙΝΩΝΙΚΩΝ ΚΑΙ ΠΟΛΙΤΙΚΩΝ ΕΠΙΣΤΗΜΩΝ',
      //     'departmentID': 125,
      //     'departmentName': 'ΠΟΛΙΤΙΚΗΣ ΕΠΙΣΤΗΜΗΣ ΚΑΙ ΙΣΤΟΡΙΑΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΟΙΝΩΝΙΚΩΝ ΚΑΙ ΠΟΛΙΤΙΚΩΝ ΕΠΙΣΤΗΜΩΝ',
      //     'departmentID': 126,
      //     'departmentName': 'ΚΟΙΝΩΝΙΟΛΟΓΙΑΣ (ΑΘΗΝΑ) - ΠΑΝΤΕΙΟ'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΟΙΝΩΝΙΚΩΝ ΚΑΙ ΠΟΛΙΤΙΚΩΝ ΕΠΙΣΤΗΜΩΝ',
      //     'departmentID': 152,
      //     'departmentName': 'ΟΙΚΟΝΟΜΙΚΗΣ ΚΑΙ ΠΕΡΙΦΕΡΕΙΑΚΗΣ ΑΝΑΠΤΥΞΗΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΟΙΝΩΝΙΚΩΝ ΚΑΙ ΠΟΛΙΤΙΚΩΝ ΕΠΙΣΤΗΜΩΝ',
      //     'departmentID': 153,
      //     'departmentName': 'ΕΠΙΚΟΙΝΩΝΙΑΣ, ΜΕΣΩΝ ΚΑΙ ΠΟΛΙΤΙΣΜΟΥ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΟΙΝΩΝΙΚΩΝ ΚΑΙ ΠΟΛΙΤΙΚΩΝ ΕΠΙΣΤΗΜΩΝ',
      //     'departmentID': 159,
      //     'departmentName': 'ΚΟΙΝΩΝΙΚΗΣ ΠΟΛΙΤΙΚΗΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΟΙΝΩΝΙΚΩΝ ΚΑΙ ΠΟΛΙΤΙΚΩΝ ΕΠΙΣΤΗΜΩΝ',
      //     'departmentID': 165,
      //     'departmentName': 'ΚΟΙΝΩΝΙΚΗΣ ΑΝΘΡΩΠΟΛΟΓΙΑΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΟΙΝΩΝΙΚΩΝ ΚΑΙ ΠΟΛΙΤΙΚΩΝ ΕΠΙΣΤΗΜΩΝ',
      //     'departmentID': 170,
      //     'departmentName': 'ΨΥΧΟΛΟΓΙΑΣ (ΑΘΗΝΑ) - ΠΑΝΤΕΙΟ'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΝΤΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ ΚΟΙΝΩΝΙΚΩΝ ΚΑΙ ΠΟΛΙΤΙΚΩΝ ΕΠΙΣΤΗΜΩΝ',
      //     'departmentID': 179,
      //     'departmentName': 'ΔΙΕΘΝΩΝ, ΕΥΡΩΠΑΪΚΩΝ ΚΑΙ ΠΕΡΙΦΕΡΕΙΑΚΩΝ ΣΠΟΥΔΩΝ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΑΤΡΙΑΡΧΙΚΗ ΑΝΩΤΑΤΗ ΕΚΚΛΗΣΙΑΣΤΙΚΗ ΑΚΑΔΗΜΙΑ ΚΡΗΤΗΣ',
      //     'departmentID': 416,
      //     'departmentName': 'ΠΡΟΓΡΑΜΜΑ ΙΕΡΑΤΙΚΩΝ ΣΠΟΥΔΩΝ ΗΡΑΚΛΕΙΟΥ ΚΡΗΤΗΣ'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΟΛΥΤΕΧΝΕΙΟ ΚΡΗΤΗΣ',
      //     'departmentID': 214,
      //     'departmentName': 'ΧΗΜΙΚΩΝ ΜΗΧΑΝΙΚΩΝ ΚΑΙ ΜΗΧΑΝΙΚΩΝ ΠΕΡΙΒΑΛΛΟΝΤΟΣ (ΧΑΝΙΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΟΛΥΤΕΧΝΕΙΟ ΚΡΗΤΗΣ',
      //     'departmentID': 230,
      //     'departmentName': 'ΜΗΧΑΝΙΚΩΝ ΠΑΡΑΓΩΓΗΣ ΚΑΙ ΔΙΟΙΚΗΣΗΣ (ΧΑΝΙΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΟΛΥΤΕΧΝΕΙΟ ΚΡΗΤΗΣ',
      //     'departmentID': 242,
      //     'departmentName': 'ΜΗΧΑΝΙΚΩΝ ΟΡΥΚΤΩΝ ΠΟΡΩΝ (ΧΑΝΙΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΟΛΥΤΕΧΝΕΙΟ ΚΡΗΤΗΣ',
      //     'departmentID': 331,
      //     'departmentName': 'ΗΛΕΚΤΡΟΛΟΓΩΝ ΜΗΧΑΝΙΚΩΝ ΚΑΙ ΜΗΧΑΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ (ΧΑΝΙΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΟΛΥΤΕΧΝΕΙΟ ΚΡΗΤΗΣ',
      //     'departmentID': 370,
      //     'departmentName': 'ΑΡΧΙΤΕΚΤΟΝΩΝ ΜΗΧΑΝΙΚΩΝ (ΧΑΝΙΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΥΡΟΣΒΕΣΤΙΚΗ ΑΚΑΔΗΜΙΑ',
      //     'departmentID': 871,
      //     'departmentName': 'ΑΞΙΩΜΑΤΙΚΩΝ ΠΥΡΟΣΒΕΣΤΙΚΗΣ ΑΚΑΔΗΜΙΑΣ (ΜΟΝΟ ΓΙΑ ΠΥΡΟΣΒΕΣΤΕΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΥΡΟΣΒΕΣΤΙΚΗ ΑΚΑΔΗΜΙΑ',
      //     'departmentID': 876,
      //     'departmentName': 'ΣΧΟΛΗ ΠΥΡΟΣΒΕΣΤΩΝ (ΜΟΝΟ ΓΙΑ ΠΟΛΙΤΕΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΠΥΡΟΣΒΕΣΤΙΚΗ ΑΚΑΔΗΜΙΑ',
      //     'departmentID': 877,
      //     'departmentName': 'ΑΞΙΩΜΑΤΙΚΩΝ ΠΥΡΟΣΒΕΣΤΙΚΗΣ ΑΚΑΔΗΜΙΑΣ (ΜΟΝΟ ΓΙΑ ΠΟΛΙΤΕΣ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΣΤΡΑΤΙΩΤΙΚΗ ΣΧΟΛΗ ΑΞΙΩΜΑΤΙΚΩΝ ΣΩΜΑΤΩΝ',
      //     'departmentID': 831,
      //     'departmentName': 'ΙΑΤΡΙΚΟ (ΣΣΑΣ) ΘΕΣ/ΝΙΚΗΣ'
      //   },
      //   {
      //     'departmentInstitution': 'ΣΤΡΑΤΙΩΤΙΚΗ ΣΧΟΛΗ ΑΞΙΩΜΑΤΙΚΩΝ ΣΩΜΑΤΩΝ',
      //     'departmentID': 836,
      //     'departmentName': 'ΟΔΟΝΤΙΑΤΡΙΚΟ (ΣΣΑΣ) ΘΕΣ/ΝΙΚΗΣ'
      //   },
      //   {
      //     'departmentInstitution': 'ΣΤΡΑΤΙΩΤΙΚΗ ΣΧΟΛΗ ΑΞΙΩΜΑΤΙΚΩΝ ΣΩΜΑΤΩΝ',
      //     'departmentID': 841,
      //     'departmentName': 'ΚΤΗΝΙΑΤΡΙΚΟ (ΣΣΑΣ) ΘΕΣ/ΝΙΚΗΣ'
      //   },
      //   {
      //     'departmentInstitution': 'ΣΤΡΑΤΙΩΤΙΚΗ ΣΧΟΛΗ ΑΞΙΩΜΑΤΙΚΩΝ ΣΩΜΑΤΩΝ',
      //     'departmentID': 846,
      //     'departmentName': 'ΦΑΡΜΑΚΕΥΤΙΚΟ (ΣΣΑΣ) ΘΕΣ/ΝΙΚΗΣ'
      //   },
      //   {
      //     'departmentInstitution': 'ΣΤΡΑΤΙΩΤΙΚΗ ΣΧΟΛΗ ΑΞΙΩΜΑΤΙΚΩΝ ΣΩΜΑΤΩΝ',
      //     'departmentID': 866,
      //     'departmentName': 'ΝΟΜΙΚΟ (ΣΣΑΣ) ΘΕΣ/ΝΙΚΗΣ'
      //   },
      //   {
      //     'departmentInstitution': 'ΣΤΡΑΤΙΩΤΙΚΗ ΣΧΟΛΗ ΑΞΙΩΜΑΤΙΚΩΝ ΣΩΜΑΤΩΝ',
      //     'departmentID': 867,
      //     'departmentName': 'ΟΙΚΟΝΟΜΙΚΟ (ΣΣΑΣ) ΘΕΣ/ΝΙΚΗΣ'
      //   },
      //   {
      //     'departmentInstitution': 'ΣΤΡΑΤΙΩΤΙΚΗ ΣΧΟΛΗ ΑΞΙΩΜΑΤΙΚΩΝ ΣΩΜΑΤΩΝ',
      //     'departmentID': 875,
      //     'departmentName': 'ΨΥΧΟΛΟΓΩΝ (ΣΣΑΣ) ΘΕΣ/ΝΙΚΗΣ'
      //   },
      //   {
      //     'departmentInstitution': 'ΣΤΡΑΤΙΩΤΙΚΗ ΣΧΟΛΗ ΕΥΕΛΠΙΔΩΝ',
      //     'departmentID': 801,
      //     'departmentName': 'ΕΥΕΛΠΙΔΩΝ (ΣΣΕ) – ΟΠΛΑ'
      //   },
      //   {
      //     'departmentInstitution': 'ΣΤΡΑΤΙΩΤΙΚΗ ΣΧΟΛΗ ΕΥΕΛΠΙΔΩΝ',
      //     'departmentID': 806,
      //     'departmentName': 'ΕΥΕΛΠΙΔΩΝ (ΣΣΕ) – ΣΩΜΑΤΑ'
      //   },
      //   {
      //     'departmentInstitution': 'ΣΧΟΛΗ ΑΞΙΩΜΑΤΙΚΩΝ ΝΟΣΗΛΕΥΤΙΚΗΣ',
      //     'departmentID': 851,
      //     'departmentName': 'ΑΞΙΩΜΑΤΙΚΩΝ ΝΟΣΗΛΕΥΤΙΚΗΣ (ΣΑΝ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΣΧΟΛΗ ΙΚΑΡΩΝ',
      //     'departmentID': 821,
      //     'departmentName': 'ΙΚΑΡΩΝ (ΣΙ) ΙΠΤΑΜΕΝΟΙ'
      //   },
      //   {
      //     'departmentInstitution': 'ΣΧΟΛΗ ΙΚΑΡΩΝ',
      //     'departmentID': 826,
      //     'departmentName': 'ΙΚΑΡΩΝ (ΣΙ) ΜΗΧΑΝΙΚΟΙ (ΣΜΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΣΧΟΛΗ ΙΚΑΡΩΝ',
      //     'departmentID': 827,
      //     'departmentName': 'ΙΚΑΡΩΝ (ΣΙ) ΕΛΕΓΚΤΕΣ ΑΕΡΑΜΥΝΑΣ'
      //   },
      //   {
      //     'departmentInstitution': 'ΣΧΟΛΗ ΙΚΑΡΩΝ',
      //     'departmentID': 884,
      //     'departmentName': 'ΙΚΑΡΩΝ (ΣΙ) ΜΕΤΕΩΡΟΛΟΓΩΝ'
      //   },
      //   {
      //     'departmentInstitution': 'ΣΧΟΛΗ ΙΚΑΡΩΝ',
      //     'departmentID': 885,
      //     'departmentName': 'ΙΚΑΡΩΝ (ΣΙ) ΕΡΕΥΝΑΣ ΠΛΗΡΟΦΟΡΙΚΗΣ'
      //   },
      //   {
      //     'departmentInstitution': 'ΣΧΟΛΗ ΙΚΑΡΩΝ',
      //     'departmentID': 886,
      //     'departmentName': 'ΙΚΑΡΩΝ (ΣΙ) ΔΙΟΙΚΗΤΙΚΩΝ'
      //   },
      //   {
      //     'departmentInstitution': 'ΣΧΟΛΗ ΙΚΑΡΩΝ',
      //     'departmentID': 887,
      //     'departmentName': 'ΙΚΑΡΩΝ (ΣΙ) ΕΦΟΔΙΑΣΤΩΝ'
      //   },
      //   {
      //     'departmentInstitution': 'ΣΧΟΛΗ ΜΟΝΙΜΩΝ ΥΠΑΞΙΩΜΑΤΙΚΩΝ NAYTIKOY',
      //     'departmentID': 864,
      //     'departmentName': 'ΜΟΝΙΜΩΝ ΥΠΑΞΙΩΜΑΤΙΚΩΝ ΝΑΥΤΙΚΟΥ (Σ.Μ.Υ.Ν.)'
      //   },
      //   {
      //     'departmentInstitution': 'ΣΧΟΛΗ ΜΟΝΙΜΩΝ ΥΠΑΞΙΩΜΑΤΙΚΩΝ ΑΕΡΟΠΟΡΙΑΣ',
      //     'departmentID': 878,
      //     'departmentName': 'ΜΟΝΙΜΩΝ ΥΠΑΞΙΩΜΑΤΙΚΩΝ ΑΕΡΟΠΟΡΙΑΣ (ΣΜΥΑ) - ΚΑΤΕΥΘΥΝΣΗ ΤΕΧΝΟΛΟΓΙΚΗΣ ΥΠΟΣΤΗΡΙΞΗΣ'
      //   },
      //   {
      //     'departmentInstitution': 'ΣΧΟΛΗ ΜΟΝΙΜΩΝ ΥΠΑΞΙΩΜΑΤΙΚΩΝ ΑΕΡΟΠΟΡΙΑΣ',
      //     'departmentID': 879,
      //     'departmentName': 'ΜΟΝΙΜΩΝ ΥΠΑΞΙΩΜΑΤΙΚΩΝ ΑΕΡΟΠΟΡΙΑΣ (ΣΜΥΑ) - ΚΑΤΕΥΘΥΝΣΗ ΕΠΙΧΕΙΡΗΣΙΑΚΗΣ ΥΠΟΣΤΗΡΙΞΗΣ'
      //   },
      //   {
      //     'departmentInstitution': 'ΣΧΟΛΗ ΜΟΝΙΜΩΝ ΥΠΑΞΙΩΜΑΤΙΚΩΝ ΑΕΡΟΠΟΡΙΑΣ',
      //     'departmentID': 880,
      //     'departmentName': 'ΜΟΝΙΜΩΝ ΥΠΑΞΙΩΜΑΤΙΚΩΝ ΑΕΡΟΠΟΡΙΑΣ (ΣΜΥΑ) - ΚΑΤΕΥΘΥΝΣΗ ΔΙΟΙΚΗΤΙΚΗΣ ΚΑΙ ΕΦΟΔΙΑΣΤΙΚΗΣ ΥΠΟΣΤΗΡΙΞΗΣ'
      //   },
      //   {
      //     'departmentInstitution': 'ΣΧΟΛΗ ΜΟΝΙΜΩΝ ΥΠΑΞΙΩΜΑΤΙΚΩΝ ΣΤΡΑΤΟΥ ΞΗΡΑΣ',
      //     'departmentID': 862,
      //     'departmentName': 'ΜΟΝΙΜΩΝ ΥΠΑΞΙΩΜΑΤΙΚΩΝ ΣΤΡΑΤΟΥ (Σ.Μ.Υ.) – ΟΠΛΑ'
      //   },
      //   {
      //     'departmentInstitution': 'ΣΧΟΛΗ ΜΟΝΙΜΩΝ ΥΠΑΞΙΩΜΑΤΙΚΩΝ ΣΤΡΑΤΟΥ ΞΗΡΑΣ',
      //     'departmentID': 863,
      //     'departmentName': 'ΜΟΝΙΜΩΝ ΥΠΑΞΙΩΜΑΤΙΚΩΝ ΣΤΡΑΤΟΥ (Σ.Μ.Υ.) – ΣΩΜΑΤΑ'
      //   },
      //   {
      //     'departmentInstitution': 'ΣΧΟΛΗ ΝΑΥΤΙΚΩΝ ΔΟΚΙΜΩΝ',
      //     'departmentID': 811,
      //     'departmentName': 'ΝΑΥΤΙΚΩΝ ΔΟΚΙΜΩΝ (ΣΝΔ) ΜΑΧΙΜΟΙ'
      //   },
      //   {
      //     'departmentInstitution': 'ΣΧΟΛΗ ΝΑΥΤΙΚΩΝ ΔΟΚΙΜΩΝ',
      //     'departmentID': 816,
      //     'departmentName': 'ΝΑΥΤΙΚΩΝ ΔΟΚΙΜΩΝ (ΣΝΔ) ΜΗΧΑΝΙΚΟΙ'
      //   },
      //   {
      //     'departmentInstitution': 'ΧΑΡΟΚΟΠΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': 144,
      //     'departmentName': 'ΟΙΚΟΝΟΜΙΑΣ ΚΑΙ ΒΙΩΣΙΜΗΣ ΑΝΑΠΤΥΞΗΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΧΑΡΟΚΟΠΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': 294,
      //     'departmentName': 'ΕΠΙΣΤΗΜΗΣ ΔΙΑΙΤΟΛΟΓΙΑΣ ΚΑΙ ΔΙΑΤΡΟΦΗΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΧΑΡΟΚΟΠΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': 356,
      //     'departmentName': 'ΓΕΩΓΡΑΦΙΑΣ (ΑΘΗΝΑ)'
      //   },
      //   {
      //     'departmentInstitution': 'ΧΑΡΟΚΟΠΕΙΟ ΠΑΝΕΠΙΣΤΗΜΙΟ',
      //     'departmentID': 412,
      //     'departmentName': 'ΠΛΗΡΟΦΟΡΙΚΗΣ ΚΑΙ ΤΗΛΕΜΑΤΙΚΗΣ (ΑΘΗΝΑ)'
      //   }
      // ],
      loadingDepts: false
    }
  },
  computed: {
    scoreMatchString () {
      return this.application.scoreMatch ? 'NAI' : 'OXI'
    },
    distant () {
      return this.application.titles.distant ? 'Εξ αποστάσεως' : 'Συμβατικός'
    },
    isCorrespondence () {
      if (this.application.recognitionWith === 'aeiAndTei') {
        return 'με Πανεπιστήμιο ή με ΤΕΙ'
      } else if (this.application.recognitionWith === 'aei') {
        return ' μόνο με Πανεπιστήμιο'
      } else if (this.application.recognitionWith === 'tei') {
        return ' μόνο με ΤΕΙ'
      } else {
        return ' χωρίς'
      }
    },
    isConsideration () {
      // return this.application.correspondence ? 'Αντιστοιχία και Ισοτιμία' : 'Ισοτιμία'
      return this.application.consideration ? 'Ακαδημαϊκή ισοδυναμία με συνυποβολή τίτλου 2ου κύκλου σπουδών' : 'Ακαδημαϊκή ισοδυναμία'
    },
    ...mapGetters({ activeRole: 'activeRole' })
  },
  methods: {
    listAllDepartments () {
      this.loadingDepts = true
      this.showUniList = true
      axios.get(
        `${config.BASE_URL}/greekInstitutions`
      )
        .then(response => {
          this.loadingDepts = false
          this.allDepartments = response.data.data
        })
    }
  }
}
</script>

<style scoped lang="scss">
.el-form-item {
  color: rgb(30, 0, 128);
  font-weight: bold;
  // border-radius: 10px;
  // border-style: solid;
  // border-color: #7fa3bb green #86b8da yellow;
  // border-width: 0px 0px 2px 0px;
  // border: 2px 0px 0px 0px solid #7fa3bb;
  padding-right: 20px;
  padding-left: 10px;
}
// .el-input.is-disabled .el-input__inner {
//   background-color: #f5f7fa;
//   border-color: #e4e7ed;
//   color: #1b5cde;
//   cursor: not-allowed;
// }
// .el-checkbox__input.is-disabled+span.el-checkbox__label {
//   color: #1b91de;
// }
// input.el-input__inner {
//   color: #3e67b9;
// }
.el-input {
  &.bigger {
    width: 530px;
  }
}
.el-input {
  &.biggest {
    width: 1040px;
  }
}
.el-input {
  &.big {
    width: 450px;
    color: #3e67b9;
  }
}
.el-input--small .el-input__inner {
  width: 300px
}
.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 190px;
}
.el-checkbox__input.is-disabled+span.el-checkbox__label {
  color: #1b91de;
}
.el-alert {
  background-color: unset;
  font-style: normal;
  text-align:left;
  display: inline;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Titles.vue